<template>
  <!-- <pre>
{{brand_product_styles}}
</pre> -->
  <div v-if="siteDownMsg" style="width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center; font-size: 1.5rem; text-align: center; padding: 20px;">
    {{ siteDown }}
  </div>
  <div
    v-if="setbrandid"
    v-show="styles_loaded"
    :class="setbrandid"
    :style="new_style_variables"
  >
    <Header
      :key="updateHeader + setbrandid + lang"
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="0"
      :logo_image="logo_image"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
      :basket_is_model="true"
      :popup_page="'results'"
    ></Header>

    <div class="page-bg" :style="set_style_variables">
      <div class="results-banner-container">
        <ResultsBanner
          :headline="getrans(results_headline)"
          :subheadline="getrans(results_subheadline)"
          edit-label="Edit"
        >
          <template v-slot:filters>
            <div class="banner-filters">
              <div
                v-show="closeest_cheapest === 'cheapest'"
                class="banner-filters__close-cheap"
                @click.prevent="setListOrder('closest')"
              >
                {{ getrans("Cheapest first") }}&nbsp;&nbsp;<i
                  class="fas fa-chevron-down"
                ></i>
              </div>

              <div
                v-show="closeest_cheapest === 'closest'"
                class="banner-filters__close-cheap"
                @click.prevent="setListOrder('cheapest')"
              >
                {{ getrans("Closest First") }}&nbsp;&nbsp;<i
                  class="fas fa-chevron-down"
                ></i>
              </div>

              <!-- 
            <div class="banner-filters__list-map-view">
              List view&nbsp;&nbsp;<i class="fas fa-chevron-down"></i>
            </div> -->
              <div
                v-if="setbrandid === 'LAX'"
                class="banner-filters__edit-search filters-button"
                @click.prevent="filters_toggle = !filters_toggle"
              >
                {{ getrans("Filters") }}
              </div>

              <div
                class="banner-filters__edit-search"
                @click.prevent="showSearchWidget = !showSearchWidget"
              >
                <template v-if="setbrandid === 'AIR'">
                  {{ getrans("Edit Search") }}&nbsp;&nbsp;<i
                    class="fas fa-edit"
                  ></i>
                </template>
                <template v-else-if="setbrandid === 'LAX'">
                  {{ getrans("Edit Search") }}
                </template>
                <template v-else-if="setbrandid === 'PIT'">
                  {{ getrans("EDIT RESERVATION") }}
                </template>
                <template v-else>
                  {{ getrans("Edit") }}&nbsp;&nbsp;<i class="fas fa-edit"></i>
                </template>
              </div>
            </div>
          </template>
          <template v-slot:widget>
            <div class="search-widget-desktop" v-show="showSearchWidget">
              <div class="search-widget-results">
                <SearchWidget
                  v-if="brandloaded && setbrandid"
                  :brand_slug="setbrandid"
                  showTabs="parking"
                  activeTab="parking"
                  hideTabs="true"
                  :dateStart="date1_forwidget"
                  :dateEnd="date2_forwidget"
                  :key="date1_forwidget"
                  :lang="lang"
                  :venue_select="venue_select"
                />
              </div>
            </div>
          </template>
        </ResultsBanner>
      </div>

      <div
        class="results-filter-container"
        :class="results_filters ? 'has-results-filters' : ''"
        v-if="results_filters"
      >
        <slide-up-down v-model="filters_toggle" :duration="200">
          <div class="search-filters" v-if="results_filters">
            <div class="search-filters-inner">
              <div class="filter_select_wrap">
                <select
                  class="filter_select"
                  v-if="airline_list.length"
                  id="airline_select"
                  v-model="airline_select"
                  @change="
                    [
                      onAirlineSelectChange(),
                      onTerminalSelectChange(),
                      onProductSelectChange(),
                    ]
                  "
                  :ref="`airline_select`"
                >
                  <option value="0" disabled>
                    {{ getrans("Select Airline") }}
                  </option>
                  <option value="All">
                    {{ getrans("I don't know") }}
                  </option>
                  <option
                    v-for="airline in airline_list"
                    :value="airline.airline_id"
                    :key="airline.airline_name"
                    :data-airline-name="airline.airline_name"
                  >
                    {{ getrans(airline.airline_name) }}
                  </option>
                </select>
                <i
                  @click="
                    airline_select = 'All';
                    airline_terminal_list = [];
                    terminal_select = '0';
                    terminal_pill_name = '';
                    onProductSelectChange();
                  "
                  class="fas fa-times"
                ></i>
              </div>

              <div class="filter_select_wrap">
                <select
                  class="filter_select"
                  id="terminal_select"
                  v-model="terminal_select"
                  v-if="airline_terminal_list.length"
                  @change="[onTerminalSelectChange(), onProductSelectChange()]"
                  :ref="`terminal_select`"
                >
                  <option value="0" disabled>
                    {{ getrans("Select Terminal") }}
                  </option>
                  <template
                    v-for="terminal in terminal_list"
                    :key="terminal.terminal_id"
                  >
                    <option
                      :value="terminal.terminal_id"
                      :data-terminal-name="terminal.terminal_id"
                      :disabled="
                        airline_terminal_list.indexOf(terminal.terminal_id) ===
                        -1
                      "
                    >
                      {{ getrans(terminal.terminal_name) }}
                    </option>
                  </template>
                </select>
                <select
                  class="filter_select"
                  id="terminal_select"
                  v-else
                  v-model="terminal_select"
                  @change="[onTerminalSelectChange(), onProductSelectChange()]"
                  :ref="`terminal_select`"
                >
                  <option value="0" disabled>
                    {{ getrans("Select Terminal") }}
                  </option>
                  <template
                    v-for="terminal in terminal_list"
                    :key="terminal.terminal_id"
                  >
                    <option
                      :value="terminal.terminal_id"
                      :data-terminal-name="terminal.terminal_id"
                    >
                      {{ getrans(terminal.terminal_name) }}
                    </option>
                  </template>
                </select>
                <i
                  style="
                    max-width: 0px;
                    opacity: 0;
                    pointer-events: none;
                    padding: 1rem 0;
                  "
                  class="fas fa-times"
                ></i>
              </div>

              <div class="filter_select_wrap">
                <select
                  class="filter_select"
                  v-if="product_list.length"
                  id="product_select"
                  v-model="product_select"
                  @change="onProductSelectChange"
                  :ref="`product_select`"
                >
                  <option value="0" disabled>
                    {{ getrans("Select Product Feature") }}
                  </option>
                  <option
                    v-for="product in product_list"
                    :value="product.product_feature_id"
                    :key="product.product_feature_id"
                    :data-product-name="product.product_feature_name"
                    :disabled="
                      filtered_product_list.indexOf(
                        product.product_feature_id
                      ) === -1
                    "
                  >
                    {{ getrans(product.product_feature_name) }}
                  </option>
                </select>
                <i
                  @click="
                    product_select = 0;
                    terminal_pill_name === '' ? onAirlineSelectChange() : null;
                    onProductSelectChange();
                  "
                  class="fas fa-times"
                ></i>
              </div>

              <div class="filter_select_wrap">
                <select
                  class="filter_select"
                  name="sort-dropdown"
                  id="sort-dropdown"
                  v-model="sort_dropdown"
                  @change="sort_dropdown_change"
                  :ref="`sort_dropdown`"
                >
                  <option value="distance" :disabled="!terminal_pill_name">
                    {{ getrans("Distance") }}
                  </option>
                  <option value="price">{{ getrans("Price") }}</option>
                  <option value="featured">{{ getrans("Featured") }}</option>
                </select>
                <i
                  style="
                    max-width: 0px;
                    opacity: 0;
                    pointer-events: none;
                    padding: 1rem 0;
                  "
                  class="fas fa-times"
                ></i>
              </div>

              <button @click="reset_filters()">
                {{ getrans("Clear Filters") }}
              </button>
            </div>
          </div>
        </slide-up-down>
      </div>

      <div class="new-results-filter-container" v-else-if="new_results_filters">
        <div class="new-results-filter-inner">
          <div class="filter-toggles">
            <div class="slide-toggler-wrapper">
              <div
                class="slide-toggler"
                :class="filter_sortby ? 'slide-toggler-active' : ''"
                @click="filter_sortby = !filter_sortby"
              >
                <div class="filter-dropdown">
                  <template v-if="dataloaded && dataloaded_carparkdetails">
                    <div class="slide-toggler-text">
                      <h3>{{ getrans("Filters") }}</h3>
                    </div>
                    <i class="fas fa-chevron-right"></i>
                  </template>
                </div>

                <div class="keys">
                  <span
                    ><img
                      src="@/assets/images/EVIcon.png"
                      :alt="`EV Parking Icon`"
                    />
                    = {{ getrans("EV Charging") }}</span
                  >
                  <span
                    ><img
                      src="@/assets/images/MaxHeightIcon.png"
                      :alt="`Garage Parking Icon`"
                    />
                    = {{ getrans("Max Height") }}</span
                  >
                  <span><InfoIcon /> = {{ getrans("More Info") }}</span>
                </div>
              </div>
              <slide-up-down v-model="filter_sortby" :duration="200">
                <div class="filter-content">
                  <div class="filter-content-sort">
                    <div class="filter-content-label">
                      {{ getrans("Sort by:") }}
                    </div>
                    <div>
                      <label
                        class="filter-content-sort__label"
                        for="sort-dropdown"
                      >
                        <input
                          type="radio"
                          name="sort-dropdown"
                          value="distance"
                          v-model="selectedSort"
                          @change="onSortChange"
                        />
                        {{ getrans("Distance") }}
                      </label>
                    </div>
                    <div>
                      <label
                        class="filter-content-sort__label"
                        for="sort-dropdown"
                      >
                        <input
                          type="radio"
                          name="sort-dropdown"
                          value="price"
                          v-model="selectedSort"
                          @change="onSortChange"
                        />
                        {{ getrans("Price") }}
                      </label>
                    </div>

                    <div class="sort-display">
                      {{ getrans("Selected sort:") }} {{ selectedSort }}
                    </div>
                  </div>
                  <div class="filter-content-price">
                    <div class="filter-content-label">
                      {{ getrans("Price Range") }}
                    </div>
                    <div>
                      {{ currency_formatter(price_slider_value[0]) }} -
                      {{ currency_formatter(price_slider_value[1]) }}
                    </div>
                    <div
                      class="filter-content-slider"
                      v-if="dataloaded && dataloaded_carparkdetails"
                    >
                      <vue-slider
                        v-model="price_slider_value"
                        :data="prices_array"
                        :enable-cross="false"
                        :minRange="1"
                        :marks="true"
                        :hide-label="true"
                        :tooltip-formatter="currency_formatter"
                        :tooltip-placement="'bottom'"
                        :lazy="true"
                      />
                    </div>
                  </div>
                  <!-- {{get_prices_array()}} -->
                </div>
              </slide-up-down>
            </div>
          </div>
        </div>
      </div>

      <div
        class="results-filter-container results-filters-radio-style"
        :class="results_filters ? 'has-results-filters' : ''"
        v-else-if="new_list_grid_view()"
      >
        <div class="results-filter" v-if="!results_filters">
          <div class="results-filter__style results-filter__style--radio">
            <label class="radio-style-option">
              <input
                type="radio"
                name="view-style"
                value="list"
                v-model="result_selected_style"
                @change="setListStyle('list')"
              />
              <span>
                {{ getrans("List") }}
              </span>
            </label>
            <label class="radio-style-option">
              <input
                type="radio"
                name="view-style"
                value="grid"
                v-model="result_selected_style"
                @change="setListStyle('grid')"
              />
              <span>
                {{ getrans("Grid") }}
              </span>
            </label>
          </div>

          <div class="results-filter__style results-filter__style--radio">
            <!-- <select
              class="c-widget__select"
              id="venue_select"
              v-model="terminal_select"
            >
              <option
                v-for="terminal in terminal_list"
                :value="terminal.terminal_id"
                :key="terminal.terminal_id"
                :data-terminal-name="terminal.terminal_id"
              >
                {{ getrans(terminal.terminal_name) }}
              </option>
            </select> -->

            <label class="radio-style-option">
              <input
                type="radio"
                name="closest-cheapest"
                value="distance"
                v-model="selectedSort"
                @change="onSortChange"
              />
              <span>
                {{ getrans("Closest First") }}
              </span>
            </label>

            <label class="radio-style-option">
              <input
                type="radio"
                name="closest-cheapest"
                value="price"
                v-model="selectedSort"
                @change="onSortChange"
              />
              <span>
                {{ getrans("Cheapest First") }}
              </span>
            </label>
          </div>
        </div>
      </div>

      <div
        class="results-filter-container"
        :class="results_filters ? 'has-results-filters' : ''"
        v-else
      >
        <div class="results-filter" v-if="!results_filters">
          <div class="results-filter__style">
            <button
              href="#"
              :class="[result_selected_style === 'list' ? 'active' : '']"
              @click.prevent="setListStyle('list')"
            >
              <i class="fa fa fa-th-list" aria-hidden="true"></i>
              {{ getrans("List") }}
            </button>
            <button
              href="#"
              :class="[result_selected_style === 'grid' ? 'active' : '']"
              @click.prevent="setListStyle('grid')"
            >
              <i class="fa fa-th" aria-hidden="true"></i> {{ getrans("Grid") }}
            </button>
          </div>

          <div class="results-filter__order">
            <!-- <select
              class="c-widget__select"
              id="venue_select"
              v-model="terminal_select"
            >
              <option
                v-for="terminal in terminal_list"
                :value="terminal.terminal_id"
                :key="terminal.terminal_id"
                :data-terminal-name="terminal.terminal_id"
              >
                {{ getrans(terminal.terminal_name) }}
              </option>
            </select> -->
            <button
              href="#"
              :class="[result_selected_order === 'closest' ? 'active' : '']"
              @click.prevent="setListOrder('closest')"
            >
              {{ getrans("Closest First") }}
            </button>

            <button
              href="#"
              :class="[result_selected_order === 'cheapest' ? 'active' : '']"
              @click.prevent="setListOrder('cheapest')"
            >
              {{ getrans("Cheapest First") }}
            </button>
          </div>
        </div>
      </div>

      <!-- {{ airline_select }} - {{ terminal_select }} <br />

      {{ sort_by_distance_data }} <br /><br />

      {{ distances_data }} -->

      <!-- {{ searchres_filtered }} <br /><br />
      {{ featured_product }} -->

      <template v-if="false && results_filters">
        <div class="search-pills">
          <!-- {{airline_select}} -->
          <div class="search-pills-inner">
            <div v-if="airline_list.length">
              <template
                v-for="airline in airline_list"
                :key="airline.airline_name"
              >
                <div
                  class="pill"
                  v-if="Number(airline_select) === airline.airline_id"
                >
                  {{ getrans(airline.airline_name) }}
                  <i
                    @click="
                      airline_select = 'All';
                      airline_terminal_list = [];
                      terminal_select = '0';
                      terminal_pill_name = '';
                      onProductSelectChange();
                    "
                    class="fas fa-times"
                  ></i>
                </div>
              </template>
            </div>

            <div class="pill" v-if="terminal_pill_name">
              {{ getrans(terminal_pill_name) }}
              <!-- <i
                @click="
                  terminal_select = '0';
                  terminal_pill_name = '';
                  onAirlineSelectChange();
                  onProductSelectChange();
                "
                class="fas fa-times"
              ></i> -->
            </div>

            <template
              v-for="product in product_list"
              :key="product.product_feature_id"
            >
              <div
                class="pill"
                v-if="Number(product_select) === product.product_feature_id"
              >
                {{ getrans(product.product_feature_name) }}
                <i
                  @click="
                    product_select = 0;
                    terminal_pill_name === '' ? onAirlineSelectChange() : null;
                    onProductSelectChange();
                  "
                  class="fas fa-times"
                ></i>
              </div>
            </template>
          </div>

          <div class="search-pills-inner">
            <div class="view-buttons">
              <button
                href="#"
                :class="[result_selected_style === 'list' ? 'active' : '']"
                @click.prevent="setListStyle('list')"
              >
                <!-- <i class="fa fa fa-th-list" aria-hidden="true"></i> -->
                {{ getrans("List") }}
              </button>
              <button
                href="#"
                :class="[result_selected_style === 'grid' ? 'active' : '']"
                @click.prevent="setListStyle('grid')"
              >
                <!-- <i class="fa fa-th" aria-hidden="true"></i>  -->
                {{ getrans("Grid") }}
              </button>
            </div>

            <div class="sort-dropdown">
              <!-- <img src="@/assets/images/sort_arrows_left.svg" /> -->
              <label for="sort-dropdown"
                >{{ getrans("Sort by") }}:
                <select
                  name="sort-dropdown"
                  id="sort-dropdown"
                  v-model="sort_dropdown"
                  @change="sort_dropdown_change"
                  :ref="`sort_dropdown`"
                >
                  <option value="distance" :disabled="!terminal_pill_name">
                    {{ getrans("Distance") }}
                  </option>
                  <option value="price">{{ getrans("Price") }}</option>
                  <option value="featured">{{ getrans("Featured") }}</option>
                </select>
              </label>
              <!-- <img src="@/assets/images/sort_chevs_right.svg" /> -->
            </div>
          </div>
        </div>
      </template>
      
      <div
        class="keys-wrapper"
        v-if="new_results === 'condensed' && results_filters"
      >
        <div class="keys">
          <span><InfoIcon /> = {{ getrans("More Info") }}</span>
          <span
            ><img src="@/assets/images/EVIcon.png" :alt="`EV Parking Icon`" /> =
            {{ getrans("EV Charging") }}</span
          >
          <span
            ><img
              src="@/assets/images/MaxHeightIcon.png"
              :alt="`Garage Parking Icon`"
            />
            = {{ getrans("Max Height") }}</span
          >
        </div>
      </div>

      <div class="results-container">
        <div class="loading-results" v-if="!dataloaded && !noSlotsAvailable">
          <i class="fas fa-circle-notch fa-spin"></i>&nbsp;
          <template v-if="setbrandid === 'BHX'">{{
            getrans("Loading your parking options and deals.. Please wait..")
          }}</template>
          <template v-else-if="setbrandid === 'PIT'"
            >{{
              getrans("Fetching parking availability and offers")
            }}...</template
          >
          <template v-else-if="setbrandid === 'HVN'"
            >{{
              getrans("Fetching parking availability and offers")
            }}...</template
          >
          <template v-else>{{ getrans("Loading") }}...</template>
        </div>

        <div class="loading-results" v-show="noSlotsAvailable">
          <template v-if="setbrandid === 'HER'">
            <p style="text-align: center">
              <!-- {{
                getrans(
                  "Sorry not available online. Please purchase at the airport."
                )
              }} -->
              {{
                getrans(
                  "Online parking is fully booked. Limited spaces may be available on arrival."
                )
              }}
            </p>
            <br />
          </template>
          <template v-else-if="setbrandid === 'NQY'">
            <p style="text-align: center">
              {{ getrans("Thank you for trying to pre-book your parking with Cornwall Airport Newquay.") }}
              <br />
              {{
                getrans(
                  "Unfortunately there are no pre-booked spaces available for the dates that you have selected."
                )
              }}
              <br />
              {{
                getrans(
                  "Please note there are no bookings available for periods of less than 12 hours."
                )
              }}
              <br />
              {{
                getrans(
                  "If you haven’t been able to book your parking there will be park and pay spaces available in our East and West Car Parks,  simply park and pay at one of the onsite pay stations or via the JustPark app."
                )
              }}
            </p>
            <!-- <p style="text-align: center">
              {{ getrans("Thank you for trying to pre-book your parking.") }}
              <br />
              {{
                getrans(
                  "Unfortunately, there are no pre-book spaces available during your stay."
                )
              }}
              <br />
              {{
                getrans(
                  "There will be space when you arrive on-site, and you can pay on arrival."
                )
              }}
            </p> -->
            <br />
          </template>
          <template v-else-if="setbrandid === 'IP1'">
            {{
              getrans(
                "It looks like we have no availability for your required dates. Please try a different date or check our FAQs."
              )
            }}
          </template>
          <template v-else-if="setbrandid === 'ML1'">
            {{
              getrans(
                "No Availability, please contact the Ocean Village team on 02380 229 385"
              )
            }}
          </template>
          <template v-else-if="setbrandid === 'HVN'">
            <!-- <span style="max-width: 70ch"
              >
              On-site parking reservations are sold out for your travel dates. Reserve parking at Long Wharf Garage <a href="https://parkhvn.com/" target="_blank">here</a>.<br><br>
              Limited drive‑up parking may be available on‑site on a first‑come, first‑served basis. Check real‑time availability <a href="https://parkhvn.com/" target="_blank">here</a> before leaving for the airport.
            </span> -->
          </template>
          <template v-else-if="setbrandid === 'LAX'">
            {{
              getrans(
                "Sorry prebooking for more than 30 days stay is not available online. Please drive up to the car park."
              )
            }}
          </template>
          <template v-else-if="setbrandid === 'PB1'">
            <!-- {{
              getrans(
                "Sorry not available online. Please purchase at the car park."
              )
            }} -->
          </template>
          <template v-else-if="setbrandid === 'SZG'">
            <span style="max-width: 70ch">
            {{
              getrans(
                "Unfortunately, no parking spaces are available online for the selected period. Please contact the airport."
              )
            }}
            <br/><br/>
            {{
              getrans(
                "Bookings of less than four hours are not possible. Please drive up to your chosen parking space and pull a ticket. Thank you."
              )
            }}
            </span>
          </template>
          <template v-else>
            {{
              getrans(
                "Sorry not available online. Please purchase at the airport."
              )
            }}
          </template>
        </div>

        <div
          class="loading-results loading-results-left"
          v-if="advanced_search_error"
          :key="advanced_search_error"
          > {{ getrans(advanced_search_error || "") }}
        </div>

        <div
          class="loading-results loading-results-left"
          v-show="dataloaded && nonVisableMessage && !advanced_search_error"
        >
          <template v-if="setbrandid === 'YHM' || setbrandid === 'SV1'">
            <p>
              <b>
                {{ getrans("Outside allowable duration for bookings:") }}
              </b>
            </p>
            <p>
              {{
                getrans(
                  "Parking reservations require a minimum duration of 24 hours. Please take a ticket at the parking lot entrance."
                )
              }}
            </p>
          </template>
          <template v-else-if="dataloaded && setbrandid === 'LDY'">
            <p>
              Not available online. Please contact the City of Derry Airport
              Customer Services team who will be happy to assist you: <br />
              tel: <a href="tel:+442871810784">+442871810784</a> or
              <a href="parking@cityofderryairport.com"
                >parking@cityofderryairport.com.</a
              >
            </p>
          </template>
          <template
            v-else-if="dataloaded && show_parking_msg && setbrandid === 'HVN'"
          >
            <p>
              {{
                getrans(
                  "A three-day minimum stay is required for parking reservations starting on a Thursday or Friday. Drive-up (non-reserved) parking may be available on a first-come, first-served basis. Prior to leaving for the airport, check real-time drive-up parking availability,"
                )
              }}&nbsp;<a href="https://parkhvn.com/#top" target="_blank">{{ getrans("here.") }}</a>
            </p>
        </template>
        <template v-else-if="show_parking_msg && setbrandid === 'PB1'">
          <p>
            {{
              getrans(
                "The selected entry or exit time falls outside our car park operating hours. Please adjust your booking accordingly."
              )
            }}
          </p>
        </template>
        <template v-else>
          <template
            v-if="dataloaded && dataloaded_carparkdetails && setbrandid === 'HVN'"
          >
            <p>
              Parking reservations are sold-out for your travel dates. Limited drive-up parking may be available on-site on a first-come, first-served basis. Check real-time availability <a target="_blank" href="https://parkhvn.com/">here</a> before leaving for the airport.
            </p>
          </template>
          <template
            v-else-if="dataloaded && dataloaded_carparkdetails && setbrandid === 'NQY'"
          ></template>
          <template
            v-else-if="dataloaded && dataloaded_carparkdetails && setbrandid === 'SZG'"
          ></template>
          <template
            v-else-if="dataloaded && dataloaded_carparkdetails && setbrandid === 'PB1'"
          >
            <p>
              {{
                getrans(
                  "The selected entry or exit time falls outside our car park operating hours. Please adjust your booking accordingly."
                )
              }}
            </p>
          </template>
          <template
            v-else-if="dataloaded && dataloaded_carparkdetails && setbrandid === 'NOC'"
          >
            <p>
              {{
                getrans(
                  "Bookings can only be made at least 12 hours in advance. If your arrival is within the next 12 hours, please drive up to the parking facility of your choice and pull a ticket. Thank you."
                )
              }}
            </p>
          </template>
          <template
            v-else-if="dataloaded && dataloaded_carparkdetails && setbrandid === 'HER'"
          >
            <p>
              {{
                getrans(
                  "Bookings less than eight hours cannot be completed. Please drive up to the parking facility of your choice and pull a ticket. Thank you."
                )
              }}
            </p>
          </template>
           <template v-else-if="dataloaded && dataloaded_carparkdetails">
            <p>
              {{
                getrans(
                  "Bookings less than four hours cannot be completed. Please drive up to the parking facility of your choice and pull a ticket. Thank you."
                )
              }}
            </p>
          </template>
        </template>
      </div>

        <!-- <div class="proceed-to-checkout">
        <button>{{ getrans("Proceed to Checkout") }}</button>
      </div> -->

        <div v-if="setbrandid === 'PIT'" style="text-align: center; padding: 0 1rem; margin: 0 auto 2rem !important;  max-width: 70ch;">
          <b>Pre-book early for the best available rates.  PIT parking provides the closest and easiest airport parking experience.</b>
        </div>

        <template
          v-if="
            result_selected_style === 'list' &&
            dataloaded &&
            dataloaded_carparkdetails
          "
        >
          <div
            class="results-list"
            :class="new_results === 'condensed' ? 'results-condensed' : ''"
          >
            <component
              v-if="ResultsList"
              :is="ResultsList"
              color="color-01"
              :searchres="searchres_filtered"
              :carparkdetails="carparkdetails"
              :parkingproductdetails="parkingproductdetails"
              :venue_select_name="venue_select_name"
              :date1_date="date1_date"
              :date1_time="date1_time"
              :date2_date="date2_date"
              :date2_time="date2_time"
              :key="neworder_key"
              :lang="lang.toUpperCase()"
              :translations="translations"
              :brandSlug="setbrandid"
              :distances_data="distances_data"
              :book_button_text="book_button_text"
            />
          </div>
        </template>

        <template
          v-if="
            result_selected_style === 'grid' &&
            dataloaded &&
            dataloaded_carparkdetails
          "
        >
          <div
            class="results-grid"
            :class="new_results === 'condensed' ? 'results-condensed' : ''"
          >
            <component
              v-if="ResultsGrid"
              :is="ResultsGrid"
              color="color-01"
              :searchres="searchres_filtered"
              :carparkdetails="carparkdetails"
              :parkingproductdetails="parkingproductdetails"
              :date1_date="date1_date"
              :date1_time="date1_time"
              :date2_date="date2_date"
              :date2_time="date2_time"
              :venue_select_name="venue_select_name"
              :key="neworder_key"
              :lang="lang.toUpperCase()"
              :translations="translations"
              :brandSlug="setbrandid"
              :parking_additional_charges="parking_additional_charges"
              :parking_additional_value="parking_additional_value"
              :distances_data="distances_data"
              :book_button_text="book_button_text"
            />
          </div>
        </template>

        <template v-if="dataloaded && dataloaded_carparkdetails">
          <div
            class="results-mobile"
            :class="new_results === 'condensed' ? 'results-condensed' : ''"
          >
            <component
              v-if="ResultsMobile"
              :is="ResultsMobile"
              color="color-01"
              :searchres="searchres_filtered"
              :carparkdetails="carparkdetails"
              :parkingproductdetails="parkingproductdetails"
              :date1_date="date1_date"
              :date1_time="date1_time"
              :date2_date="date2_date"
              :date2_time="date2_time"
              :venue_select_name="venue_select_name"
              :key="neworder_key"
              :lang="lang.toUpperCase()"
              :translations="translations"
              :brandSlug="setbrandid"
              :parking_additional_charges="parking_additional_charges"
              :parking_additional_value="parking_additional_value"
              :distances_data="distances_data"
              :book_button_text="book_button_text"
            />
          </div>
        </template>
      </div>
    </div>

    <div
      v-if="dataloaded && setbrandid === 'HVN'"
      class="loading-results loading-results-left hvn-rsults-message-block"
      style="margin: 0rem auto 2rem; text-align: center; display: block; color:#094B6D; border: 1px solid #094B6D;"
    >
      Pre-book rates may be higher than drive-up, especially when parking is limited. Booking ahead guarantees your space.
    </div>

    <Footernwi
      v-if="setbrandid === 'NWI'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footernwi>
    <Footerpit
      v-if="setbrandid === 'PIT'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footerpit>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footer>
    <!-- <LoginModel /> -->
    <BasketModel
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></BasketModel>

    <Cookies :brandSlug="setbrandid" :translations="translations" />
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'RDU'" />
  </div>
</template>

<script>
const axios = require("axios");
var crypto = require("crypto");
const genkeys = require("rezauthlib");
import BasketModel from "../../components/BasketModel.vue";
import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";
import Footer from "../../components/Footer.vue";
import Footernwi from "../../components/FooterNWI.vue";
import Footerpit from "../../components/FooterPIT.vue";
import Header from "../../components/Header.vue";
import ResultsBanner from "../../components/ResultsBanner.vue";
// import ResultsGrid from "../../components/ResultsGrid.vue";
// import ResultsGridNew from "../../components/ResultsGridnew.vue";
// import ResultsList from "../../components/ResultsList.vue";
// import ResultsListNew from "../../components/ResultsListnew.vue";
// import ResultsMobile from "../../components/ResultsMobile.vue";
// import ResultsMobileNew from "../../components/ResultsMobilenew.vue";
import SearchWidget from "../../components/SearchWidgetCustomElement.vue";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
import InfoIcon from "../../components/infoIconSolid.vue";

/* eslint-disable */
import de from "date-format-parse/lib/locale/de";
import el from "date-format-parse/lib/locale/el";
import en from "date-format-parse/lib/locale/en";
import es from "date-format-parse/lib/locale/es";
import fr from "date-format-parse/lib/locale/fr";
import pt from "date-format-parse/lib/locale/pt";
/* eslint-enable */

//console.log(el);

import { markRaw, reactive } from "vue";

import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

import { set_style_vars } from "@/modules/set_style_vars";

import VueSlider from "vue-slider-component";
import sessionManager from "@/services/sessionManager.js";

//import Swal from "sweetalert2";

export default {
  name: "App",
  mixins: [],
  components: {
    Header,
    Footer,
    Footernwi,
    ResultsBanner,
    SearchWidget,
    Cookies,
    CookiesOld,
    BasketModel,
    Footerpit,
    InfoIcon,
    VueSlider,
  },
  data() {
    return {
      advanced_search_error: false,
      siteDown: '',
      siteDownMsg: false,
      selectedSort: "distance",
      price_slider_value: [],
      price_slider_data: [],
      prices_array: [],
      filter_sortby: false,
      filters_toggle: false,
      ResultsList: null,
      ResultsGrid: null,
      updateHeader: 0,
      book_button_text: "Book",
      unavailable_button_text: "Unavailable",
      distances_data: [],
      sort_by_distance_data: [],
      sort_dropdown: "featured",
      new_results: false,
      styles_loaded: false,
      lang: "en",
      translations: "",
      setbrandid: "",
      currency: "",
      date1_forwidget: "",
      date2_forwidget: "",
      date1_date: "",
      date1_time: "",
      date2_date: "",
      date2_time: "",
      partner_id: "",
      partner_name: "",
      campaign_id: "",
      campaign_name: "",
      search_origin: "",
      searchres: [],
      venue_select: "",
      venue_select_name: "",
      carparkdetails: [],
      parkingproductdetails: [],
      brandloaded: false,
      dataloaded: false,
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "Official Airport Parking",
      results_subheadline: "",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      showSearchWidget: false,
      noSlotsAvailable: false,
      neworder: false,
      neworder_key: 0,
      closeest_cheapest: "closest",
      searchres_filtered: {},
      nonVisableMessage: false,
      terminal_list: [],
      terminal_pill_name: "",
      airline_terminal_list: [],
      terminal_select: "0",
      airline_list: [],
      airline_select: "All",
      product_list: [],
      filtered_product_list: [],
      product_select: 0,
      featured_product: [],
      proximity_list: ["3-5 mins", "5-8 mins", "8-10 mins"],
      proximity_select: 0,
      speedybook_psp_styles: {},
      privacy_policy_link: "",
      terms_and_conditions_link: "",
      faqs_link: "",
      my_account_link: "",
      parking_additional_charges: "N",
      parking_additional_value: "0.00",
      filtered_bundled_products: [],
      device_type: "",
      device_browser: "",
      device_locale: "",
      device_os: "",
      show_parking_msg: false,
      utm_campaign_name: "",
      utm_partner: "",
      utm_medium: "",
      utm_content: "",
      utm_campaign: "",
      utm_source: "",
      utm_sub_partner: "",
      utm_term: "",
      display_resolution: "",
    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles, "results");
    },
    results_filters() {
      if (
        process.env.VUE_APP_RESULTS_FILTERS &&
        JSON.parse(process.env.VUE_APP_RESULTS_FILTERS).includes(
          this.setbrandid
        )
      ) {
        return true;
      }
      return false;
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    new_list_grid_view() {
      if (
        process.env.VUE_APP_NEW_LIST_GRID_VIEW &&
        JSON.parse(process.env.VUE_APP_NEW_LIST_GRID_VIEW).includes(
          this.setbrandid
        )
      ) {
        return true;
      }
      return false;
    },
    sortUnavailableLast() {
      if (this.setbrandid !== "PIT") return;
      this.searchres_filtered = Object.values(this.searchres_filtered).sort((a, b) => {
        const aUnavailable =
          !a.grand_total ||
          a.grand_total === '0.00' ||
          !a.total_amount ||
          a.total_amount === '0.00' ||
          a.booking_applicable === 'N';
        const bUnavailable =
          !b.grand_total ||
          b.grand_total === '0.00' ||
          !b.total_amount ||
          b.total_amount === '0.00' ||
          b.booking_applicable === 'N';
        if (aUnavailable === bUnavailable) return 0;
        return aUnavailable ? 1 : -1;
      });
    },

    
    async getComponents() {
      if (this.new_results === "standard") {
        const ResultsList_module = await import(
          "../../components/ResultsListnew.vue"
        );
        const ResultsGrid_module = await import(
          "../../components/ResultsGridnew.vue"
        );
        const ResultsMobile_module = await import(
          "../../components/ResultsMobilenew.vue"
        );
        this.ResultsList = markRaw(ResultsList_module.default);
        this.ResultsGrid = markRaw(ResultsGrid_module.default);
        this.ResultsMobile = markRaw(ResultsMobile_module.default);
      } else if (this.new_results === "condensed") {
        const ResultsList_condensed = await import(
          "../../components/ResultsCondensed.vue"
        );
        this.ResultsList = markRaw(ResultsList_condensed.default);
        this.ResultsGrid = markRaw(ResultsList_condensed.default);
        this.ResultsMobile = markRaw(ResultsList_condensed.default);
      } else {
        const ResultsList_module = await import(
          "../../components/ResultsList.vue"
        );
        const ResultsGrid_module = await import(
          "../../components/ResultsGrid.vue"
        );
        const ResultsMobile_module = await import(
          "../../components/ResultsMobile.vue"
        );
        this.ResultsList = markRaw(ResultsList_module.default);
        this.ResultsGrid = markRaw(ResultsGrid_module.default);
        this.ResultsMobile = markRaw(ResultsMobile_module.default);
      }
    },
    
    currency_formatter(money) {
      if (!money) return;
      const arrayString = process.env.VUE_APP_CURRENCY_AFTER_VALUE;
      const array = JSON.parse(arrayString);
      if (array.includes(this.setbrandid)) {
        money = money.toString().replace(".", ",");
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },

    get_prices_array() {
      let sortbyprice = Object.values(this.searchres_filtered).sort(function (
        a,
        b
      ) {
        //console.log(b);
        if (b.grand_total) {
          return Number(a.grand_total) - Number(b.grand_total);
        }
      });
      sortbyprice = sortbyprice.filter((item) => {
        return item.grand_total && Number(item.grand_total) !== Number("0.00");
      });
      sortbyprice = sortbyprice.map((item) => {
        return Number(item.grand_total);
      });
      // remove dupelicates from array
      sortbyprice = sortbyprice.filter((item, index) => {
        return sortbyprice.indexOf(item) === index;
      });
      this.prices_array = sortbyprice || [];
    },

    set_min_max_prices() {
      let sortbyprice = Object.values(this.searchres_filtered).sort(function (
        a,
        b
      ) {
        //console.log(b);
        if (b.grand_total) {
          return Number(a.grand_total) - Number(b.grand_total);
        }
      });
      sortbyprice = sortbyprice.filter((item) => {
        return item.grand_total && Number(item.grand_total) !== Number("0.00");
      });
      sortbyprice = sortbyprice.map((item) => {
        return Number(item.grand_total);
      });
      // remove dupelicates from array
      sortbyprice = sortbyprice.filter((item, index) => {
        return sortbyprice.indexOf(item) === index;
      });
      this.price_slider_value = [
        sortbyprice[0],
        sortbyprice[sortbyprice.length - 1],
      ];
    },

    prices_slider_filter() {
      let firstJSON = this.searchres;
      this.searchres_filtered = firstJSON;
      // Filter the searchres_filtered based on the price_slider_value
      this.searchres_filtered = Object.values(this.searchres_filtered).filter(
        (item) => {
          if (
            item.grand_total &&
            Number(item.grand_total) >= Number(this.price_slider_value[0]) &&
            Number(item.grand_total) <= Number(this.price_slider_value[1])
          ) {
            return true;
          }
          return false;
        }
      );
      this.neworder_key++;
    },

    onSortChange() {
      if (this.selectedSort === "distance") {
        let parkingproductdetails = this.parkingproductdetails.clients || {};
        this.searchres_filtered = Object.values(this.searchres_filtered).sort(
          function (a, b) {
            let a_distance_order =
              parkingproductdetails[a.product_id] &&
              parkingproductdetails[a.product_id].distance_order
                ? parkingproductdetails[a.product_id].distance_order
                : 9999;
            let b_distance_order =
              parkingproductdetails[b.product_id] &&
              parkingproductdetails[b.product_id].distance_order
                ? parkingproductdetails[b.product_id].distance_order
                : 9999;

            return a_distance_order - b_distance_order;
          }
        );
        this.neworder_key++;
      } else if (this.selectedSort === "price") {
        this.searchres_filtered = Object.values(this.searchres_filtered).sort(
          function (a, b) {
            if (b.grand_total) {
              return Number(a.grand_total) - Number(b.grand_total);
            }
          }
        );
        this.neworder_key++;
      }
    },

    decodeQuotes(str) {
      return str.replace(/&#39;/g, "'");
    },
    sortCarparkDetails(distances_data, carpark_details) {
      const orderMap = new Map();
      distances_data.forEach((item, index) => {
        orderMap.set(item.carpark_id, index);
      });
      return carpark_details.sort((a, b) => {
        const orderA = orderMap.has(a.carpark_id)
          ? orderMap.get(a.carpark_id)
          : Infinity;
        const orderB = orderMap.has(b.carpark_id)
          ? orderMap.get(b.carpark_id)
          : Infinity;
        return orderA - orderB;
      });
    },
    sortByProductIds(firstArray, secondArray) {
      // Create a map for quick lookup of the order of product_ids
      const orderMap = new Map();
      secondArray.forEach((item, index) => {
        orderMap.set(item.product_id, index);
      });

      //alert(JSON.stringify(firstArray));
      // Sort the first array based on the order of product_ids in the second array
      return firstArray.sort((a, b) => {
        const orderA = orderMap.has(a.product_id)
          ? orderMap.get(a.product_id)
          : Infinity;
        const orderB = orderMap.has(b.product_id)
          ? orderMap.get(b.product_id)
          : Infinity;
        return orderA - orderB;
      });
    },
    sort_by_distance() {
      this.sort_by_distance_data = this.distances_data.sort(function (a, b) {
        if (
          a.distance_from_carpark === "NA" ||
          a.distance_from_carpark === "mile" ||
          a.distance_from_carpark === "miles"
        )
          return 1;
        if (
          b.distance_from_carpark === "NA" ||
          b.distance_from_carpark === "mile" ||
          b.distance_from_carpark === "miles"
        )
          return -1;
        return (
          parseFloat(a.distance_from_carpark) -
          parseFloat(b.distance_from_carpark)
        );
      });
      const sortedCarparkDetails = this.sortCarparkDetails(
        this.sort_by_distance_data,
        this.searchres_filtered
      );
      this.searchres_filtered = sortedCarparkDetails;
      this.neworder_key++;
    },
    sort_by_price() {
      this.searchres_filtered = Object.values(this.searchres_filtered).sort(
        function (a, b) {
          if (b.grand_total) {
            return Number(a.grand_total) - Number(b.grand_total);
          }
        }
      );
      this.neworder_key++;
    },
    sort_by_featured() {
      this.sort_by_distance();
      this.searchres_filtered = Object.values(this.searchres_filtered);
      const sortedFirstArray = this.sortByProductIds(
        this.searchres_filtered,
        this.featured_product
      );
      this.searchres_filtered = sortedFirstArray;
      this.sortUnavailableLast(); // <-- Add this line
      this.neworder_key++;
    },
    pre_sort() {
      // sort by carpark_id then sort the ones with the same carpark id by product_display_name where Generral is first and EV is second
      this.searchres_filtered = Object.values(this.searchres_filtered).sort(
        function (a, b) {
          return a.carpark_id - b.carpark_id;
        }
      );
      // make carparks with the same carpark id sort in this order index of general and index of ev
      this.searchres_filtered = Object.values(this.searchres_filtered).sort(
        function (a, b) {
          if (a.carpark_id === b.carpark_id) {
            if (a.product_display_name.indexOf("General") > -1) {
              return -1;
            } else if (a.product_display_name.indexOf("EV") > -1) {
              return 1;
            }
          }
        }
      );
    },

    sort_dropdown_change() {
      this.pre_sort();
      switch (this.sort_dropdown) {
        case "distance":
          this.sort_by_distance();
          break;
        case "price":
          this.sort_by_price();
          break;
        case "featured":
          this.sort_by_featured();
          break;
        default:
          break;
      }

      // Make Van Nuys last for LAX
      if (this.setbrandid === "LAX") {
        this.searchres_filtered = Object.values(this.searchres_filtered).sort(
          function (a, b) {
            if (a.product_display_name.indexOf("Van Nuys") > -1) {
              return 1;
            } else if (b.product_display_name.indexOf("Van Nuys") > -1) {
              return -1;
            }
          }
        );
        if (this.sort_dropdown !== "distance") {
          // Make Economy EV third fof LAX
          // this.searchres_filtered = Object.values(this.searchres_filtered).sort(
          //   function (a, b) {
          //     if (a.product_display_name.indexOf("Economy EV") > -1) {
          //       return -1;
          //     } else if (b.product_display_name.indexOf("Economy EV") > -1) {
          //       return 1;
          //     }
          //   }
          // );

          // Make Economy General second fof LAX
          this.searchres_filtered = Object.values(this.searchres_filtered).sort(
            function (a, b) {
              if (a.product_display_name.indexOf("Economy General") > -1) {
                return -1;
              } else if (
                b.product_display_name.indexOf("Economy General") > -1
              ) {
                return 1;
              }
            }
          );

          // Make Budget first fof LAX
          this.searchres_filtered = Object.values(this.searchres_filtered).sort(
            function (a, b) {
              if (a.product_display_name.indexOf("Budget") > -1) {
                return -1;
              } else if (b.product_display_name.indexOf("Budget") > -1) {
                return 1;
              }
            }
          );
        }
      }
    },

    reset_filters() {
      let firstJSON = this.searchres;
      this.searchres_filtered = firstJSON;
      this.pre_sort();
      this.distances_data = [];
      this.airline_select = "All";
      this.terminal_select = "0";
      this.airline_terminal_list = [];
      this.terminal_pill_name = "";
      this.product_select = "0";
      this.sort_dropdown = "featured";
      //this.proximity_select = "0";
      //this.terminal_list = [];
      this.neworder_key++;
      this.sort_dropdown_change();
    },
    onProductSelectChange() {
      //let firstJSON = this.searchres;
      // if (this.searchres_filtered.length === 0) {
      //   this.searchres_filtered = firstJSON;
      // }
      // if (this.airline_select == "All") {
      //   this.onAirlineSelectChange();
      // } else if (this.terminal_select != 0) {
      //   this.onTerminalSelectChange();
      // }

      if (this.terminal_select != 0) {
        this.onTerminalSelectChange();
      }

      if (this.product_select == "0") {
        return;
      }

      // get the ids of the products with the labeltag
      //console.log("this.searchres_filtered", this.searchres);
      let parkingproductdetails = this.parkingproductdetails.clients || {};
      let firstJSON = this.searchres;
      this.searchres_filtered = firstJSON;
      this.searchres_filtered = Object.values(this.searchres_filtered).filter(
        (item) => {
          console.log(
            "onProductSelectChange",
            item.product_id,
            parkingproductdetails
          );

          if (
            parkingproductdetails[item.product_id] &&
            parkingproductdetails[item.product_id].labeltag
          ) {
            console.log(
              "parkingproductdetails[item.product_id].labeltag",
              parkingproductdetails[item.product_id].labeltag
            );

            if (
              parkingproductdetails[item.product_id].labeltag.indexOf(
                this.product_select
              ) > -1
            ) {
              return item;
            }
          }
        }
      );
      this.neworder_key++;
      this.sort_dropdown_change();
    },
    onTerminalSelectChange() {
      const selectedTerminal = this.terminal_list.find(
        (terminal) => terminal.terminal_id === this.terminal_select
      );
      this.filterCarparkByTerminal(selectedTerminal);
      this.make_filtered_product_list();

      this.neworder_key++;
    },
    onAirlineSelectChange() {
      //this.terminal_pill_name = "";
      //this.terminal_select = '0';
      this.distances_data = [];

      // this function should just create the terinal list
      let firstJSON = this.searchres;
      this.searchres_filtered = firstJSON;
      this.airline_terminal_list = [];
      //this.terminal_select = 0;

      if (this.airline_select !== "All") {
        this.terminal_select = "0";
        this.terminal_pill_name = "";
      }

      if (this.airline_select !== "All" && this.airline_list.length) {
        this.airline_terminal_list = this.airline_list.filter((item) => {
          if (Number(item.airline_id) === Number(this.airline_select)) {
            console.log(
              "item.airline_id set 2",
              item,
              item.airline_id,
              this.airline_select
            );
            return item.terminal_list;
          }
        });

        let forListReturn = [];
        this.airline_terminal_list = this.airline_terminal_list.map((item) => {
          item.terminal_list.map((item2) => {
            forListReturn.push(item2.terminal_id);
          });
        });
        this.airline_terminal_list = forListReturn;

        // I think here it will need to loop over the terminal list and get the all the carparks, then show those products, selecting terminal narrows down to that terminal.
        console.log("this.terminal_list", this.terminal_list);
        console.log("this.airline_terminal_list", this.airline_terminal_list);

        let airline_terminal_list_ids = [];

        this.airline_terminal_list.forEach((item) => {
          console.log("airline_terminal_list item", item);
          ///airline_terminal_list_ids.push(item.terminal_id);
        });

        console.log("airline_terminal_list_ids", airline_terminal_list_ids);

        let carparkList = this.terminal_list.filter((item) => {
          if (
            airline_terminal_list_ids.indexOf(item.terminal_id) > -1 &&
            item.carpark_list.length
          ) {
            //console.log('item.carpark_list', item.carpark_list)
            return item;
          }
        });

        console.log("carparkList", carparkList, this.terminal_list);

        let carparkIDs = [];
        if (carparkList && carparkList[0] && carparkList[0].carpark_list) {
          carparkIDs = carparkList[0].carpark_list.map((item) => {
            return item.carpark_id;
          });

          this.searchres_filtered = Object.values(firstJSON).filter((item) => {
            console.log(item.carpark_id);
            if (carparkIDs.indexOf(item.carpark_id) > -1) {
              return item;
            }
          });
        } else {
          this.searchres_filtered = firstJSON;
        }
        console.log("carparkIDs", carparkIDs);

        /* this.airline_terminal_list.length === 1 ? 
          this.terminal_select = this.airline_terminal_list[0] 
          : ''; */

        this.neworder_key++;
      } else {
        this.neworder_key++;
      }

      this.terminal_select = this.airline_terminal_list[0] || "0";

      this.sort_dropdown_change();
    },
    filterCarparkByTerminal(terminal) {
      this.distances_data = [];
      if (!terminal) return;
      let firstJSON = this.searchres;
      this.searchres_filtered = firstJSON;

      console.log("filterCarparkByTerminal", terminal);

      this.terminal_pill_name = terminal.terminal_name;

      let carparkList = [];

      carparkList = this.terminal_list.filter((item) => {
        if (
          terminal.terminal_id === item.terminal_id &&
          item.carpark_list.length
        ) {
          //console.log('item.carpark_list', item.carpark_list)
          return item;
        }
      });

      console.log("carparkList", carparkList, this.terminal_list);

      let carparkIDs = [];

      if (carparkList && carparkList[0] && carparkList[0].carpark_list) {
        carparkIDs = carparkList[0].carpark_list.map((item) => {
          if (item.distance_from_carpark) {
            this.distances_data.push({
              carpark_id: item.carpark_id,
              distance_from_carpark: item.distance_from_carpark,
            });
          }
          return item.preferred === "Y" ? item.carpark_id : false;
        });

        console.log("carparkIDs", carparkIDs);
        let filtered = this.searchres_filtered.filter((item) => {
          if (item.carpark_id && carparkIDs.indexOf(item.carpark_id) > -1) {
            return item;
          }
        });

        this.distances_data.sort(function (a, b) {
          if (a.distance_from_carpark === "NA") return 1;
          if (b.distance_from_carpark === "NA") return -1;
          return (
            parseFloat(a.distance_from_carpark) -
            parseFloat(b.distance_from_carpark)
          );
        });

        this.searchres_filtered = filtered;

        console.log(
          "filterCarparkByTerminal this.searchres_filtered",
          this.searchres_filtered
        );
      } else {
        this.searchres_filtered = firstJSON;
      }
      console.log("carparkIDs", carparkIDs);

      this.neworder_key++;

      // let firstJSON = this.searchres;
      // if (!terminal) {
      //   this.searchres_filtered = firstJSON;
      //   return;
      // }
      // let arrOfCPKIds = [...terminal.carpark_list].map((item) => {
      //   return item.carpark_id;
      // });
      // this.searchres_filtered = Object.values(firstJSON).filter((item) => {
      //   if (arrOfCPKIds.indexOf(item.carpark_id) > -1) {
      //     return item;
      //   }
      // });
      // this.neworder_key++;
      this.sort_dropdown_change();
    },

    make_filtered_product_list() {
      // create filtered_product_list

      this.filtered_product_list = [];

      if (this.terminal_select == 0) {
        this.filtered_product_list = this.product_list.map((item) => {
          return item.product_feature_id;
        });
        return;
      }

      let parkingproductdetails = this.parkingproductdetails.clients || {};
      let uniqueNumbers = new Set();

      this.searchres_filtered.forEach((item) => {
        if (
          parkingproductdetails[item.product_id] &&
          parkingproductdetails[item.product_id].labeltag
        ) {
          const matches =
            parkingproductdetails[item.product_id].labeltag.match(/\d+/g);
          if (matches) {
            // Convert matches to numbers and add to the Set
            matches.forEach((num) => uniqueNumbers.add(Number(num)));
          }
        }
      });

      // Convert the Set back to an array
      this.filtered_product_list = Array.from(uniqueNumbers);

      console.log(
        "this.filtered_product_list",
        this.filtered_product_list,
        this.product_list
      );
    },

    gensessionid() {
      if (encryptStorage.getItem("search_analytics_id") === undefined) {
        let search_analytics_id = crypto.randomBytes(16).toString("base64");
        encryptStorage.setItem("search_analytics_id", search_analytics_id);
        return search_analytics_id;
      } else {
        return encryptStorage.getItem("search_analytics_id");
      }
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        if (
          process.env.VUE_APP_DEFAULT_LANG_DE &&
          JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(
            this.setbrandid
          )
        ) {
          vm.lang = "de";
        }
        vm.setSessionData("language", vm.lang);
      }

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      //console.log(vm.getSessionData("language"));
      //console.log("vm.lang");

      //console.log(this.lang);

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          //console.log("getTranscache");
          //console.log(vm.translations);
          vm.set_results_subheadline();
        } else {
          axios
            .get(
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=" +
                vm.setbrandid
            )
            .then((response) => {
              //console.log("getTranscache");
              //console.log(response);
              vm.translations = JSON.parse(response.request.response);
              store.setItem("tranlations", JSON.stringify(vm.translations));
              vm.set_results_subheadline();
            });
        }
      });
    },

    put(key, value, obj) {
      obj[key] = value;
      return obj;
    },
    setListStyle(type) {
      this.result_selected_style = type;
      localStorage.setItem("preferred_results_view", type);
    },

    sortByDistancePrice() {
      /* eslint-disable */
      this.searchres_filtered = {};
      for (let j = 0; j < this.searchres.length; j++) {
        for (let i = 0; i < this.neworder.length; i++) {
          if (
            this.searchres[j].carpark_id &&
            this.searchres[j].carpark_id === this.neworder[i]
          ) {
            this.searchres_filtered[i] = this.searchres[j];
          }
        }
      }
      /* eslint-enable */
    },
    sortByDistancePricedb() {
      /* eslint-disable */
      this.searchres_filtered = {};
      for (let j = 0; j < this.searchres.length; j++) {
        for (let i = 0; i < this.neworder.length; i++) {
          if (
            this.searchres[j].product_id &&
            this.searchres[j].product_id === this.neworder[i]
          ) {
            this.searchres_filtered[i] = this.searchres[j];
          }
        }
      }
      /* eslint-enable */
    },
    setNonVisableMessage() {
      // Prevent transient "no booking" messaging while async data is still loading.
      if (!Array.isArray(this.searchres) || this.searchres.length === 0) {
        this.nonVisableMessage = false;
        return;
      }
      let num_of_visable = 0;
      //let not_visible_count  = 0;
      for (let j = 0; j < this.searchres.length; j++) {
        console.log("test", j);
        console.log("this.searchres_filtered", j, this.searchres[j]);
        if (this.searchres[j].visible) {
          num_of_visable++;
        }
      }
      console.log("num_of_visable", num_of_visable);
      console.log("this.searchres.length", this.searchres.length);
      if (Number(num_of_visable) === Number(this.searchres.length)) {
        this.nonVisableMessage = true;
      } else {
        this.nonVisableMessage = false;
      }

      // if all entries have a grand total of 0.00 or are not booking applicable then show the message
      let allUnavailable = true;
      for (let j = 0; j < this.searchres.length; j++) {
        const entry = this.searchres[j];

        console.log("setNonVisableMessage entry", entry, entry.grand_total);

        if (
          (entry.grand_total &&
          Number(entry.grand_total) !== 0) &&
          entry.visible !== 'N'
        ) {
          allUnavailable = false;
          break;
        }
      }

      console.log("allUnavailable", allUnavailable);

      if (allUnavailable) {

        this.nonVisableMessage = true;
        return;
      }





      setTimeout(() => {
        console.log("this.show_parking_msg", this.show_parking_msg);
        this.show_parking_msg = true;
      }, 500);
    },

    setListOrder(type) {
      if (!this.carparkdetails && !this.carparkdetails.clients) {
        return false;
      }
      if (
        this.carparkdetails.clients === "null" ||
        this.carparkdetails.clients === undefined
      ) {
        return null;
      }

      if (this.closeest_cheapest === "db") {
        type = "db";
      } else {
        type = "cheapest";
      }

      if (
        this.setbrandid === "PV1" ||
        this.setbrandid === "DRW" ||
        this.setbrandid === "LDY" ||
        this.setbrandid === "ML1" ||
        this.setbrandid === "YHM"
      ) {
        type = "db";
      }
      console.log("this.closeest_cheapest aa", this.closeest_cheapest);
      if (type === "closest") {
        this.closeest_cheapest = "closest";
        this.result_selected_order = type;
        let obj = Object.values(this.carparkdetails.clients);
        let neworder = obj.sort(function (a, b) {
          if (b.distance_order) {
            return a.distance_order - b.distance_order;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      if (type === "cheapest") {
        this.closeest_cheapest = "cheapest";

        this.result_selected_order = type;
        let obj = Object.values(this.searchres);
        //console.log(obj);

        let neworder = obj.sort(function (a, b) {
          if (b.grand_total) {
            return a.grand_total - b.grand_total;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
        this.neworder = this.neworder.reverse();
      }

      if (type === "db") {
        this.closeest_cheapest = "db";

        this.result_selected_order = type;
        let obj = Object.values(this.searchres);
        //console.log(obj);

        let neworder = obj;
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].product_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }
      console.log("this.closeest_cheapest type", type);
      if (type === "db") {
        this.sortByDistancePricedb();
      } else {
        this.sortByDistancePrice();
      }
      this.setNonVisableMessage();
      if (this.setbrandid === "LAX") {
        setTimeout(() => {
          this.$refs[`sort_dropdown`].dispatchEvent(
            new Event("change", { bubbles: true })
          );
          //this.sort_dropdown_change();
        }, 0);
      }

      setTimeout(() => {
        if (this.setbrandid === "PIT" || this.setbrandid === "JER") {
          // sort by the cheapest price
          this.searchres_filtered = Object.values(this.searchres_filtered).sort(
            function (a, b) {
              if (b.grand_total) {
                return Number(a.grand_total) - Number(b.grand_total);
              }
            }
          );
          this.sortUnavailableLast(); // <-- Add this line
          this.neworder_key++;
        }
      }, 0);
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        //console.log("uidgen", uidgen);

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/brandapi/branddetailslive.php?brandslug=" +
              this.setbrandid,
            "",
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log("branddata", response.data.sorting_order);
            this.setLocalData("brand_data", response.data);
            this.closeest_cheapest = response.data.sorting_order;
            this.setMenu(response.data);
            this.createPanels(response.data);
            this.setBrandData();
          });
      }
    },
    setStyles(obj) {
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      //console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      if (d) {
        d = d.replace("st", "");
        d = d.replace("nd", "");
        d = d.replace("rd", "");
        d = d.replace("th", "");
        return d;
      }
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },

    formatTime(timeString) {
      let [hourString, minute] = timeString.split(":");
      let hour = +hourString % 24;
      return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "am" : "pm");
    },

    format_date(date, format_date) {
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        //console.log(date);
        let dt = new Date(date);
        //let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        let month = months[dt.getMonth()];
        let day =
          dt.getDate() +
          (dt.getDate() % 10 == 1 && dt.getDate() != 11
            ? "st"
            : dt.getDate() % 10 == 2 && dt.getDate() != 12
            ? "nd"
            : dt.getDate() % 10 == 3 && dt.getDate() != 13
            ? "rd"
            : "th");

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          dateString = `${pad(hours)}:${pad(mins)}`;
        }
        return dateString;
      }
    },

    format_date_with_locale(date, format_date) {
      let use12 = true;
      if (this.setbrandid === "HER") {
        use12 = false;
      }
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        let language;
        let digits = 2;
        if (this.lang === "en") {
          language = en;
        }
        if (this.lang === "el") {
          language = el;
        }
        if (this.lang === "de") {
          language = de;
        }
        if (this.lang === "fr") {
          language = fr;
        }
        if (this.lang === "es") {
          language = es;
          digits = 3;
        }
        if (this.lang === "pt") {
          language = pt;
          digits = 3;
        }
        let lang_obj;
        if (digits === 2) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            monthBeforeYear: true,
          };
        } else if (digits === 3) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            days: language.weekdaysShort,
            monthBeforeYear: true,
          };
        }

        // console.log("lang_obj");
        // console.log(lang_obj);
        let months = lang_obj.formatLocale.monthsShort;

        let dt = new Date(date);

        let month = months[dt.getMonth()];
        let day = dt.getDate() + "";

        if (this.lang === "en") {
          day =
            dt.getDate() +
            (dt.getDate() % 10 == 1 && dt.getDate() != 11
              ? "st"
              : dt.getDate() % 10 == 2 && dt.getDate() != 12
              ? "nd"
              : dt.getDate() % 10 == 3 && dt.getDate() != 13
              ? "rd"
              : "th");
        }

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          if (use12) {
            dateString = this.formatTime(`${pad(hours)}:${pad(mins)}`);
          } else {
            dateString = `${pad(hours)}:${pad(mins)}`;
          }
        }
        return dateString;
      }
    },

    get_srchana_iplatlon() {
      let vm = this;
      let data = { brand_id: this.setbrandid };
      let secsaa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETKEY
      );
      let b1sa = secsaa.b1s;
      let v2sa = secsaa.v2s;
      let a1a = secsaa.a1;
      let v1a = secsaa.v1;
      let c2sa = secsaa.c2s;
      let uidgena = secsaa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "srchana/iplatlon ",
          data,
          {
            headers: {
              b1: b1sa,
              v2: v2sa,
              c2s: c2sa,
              a1: a1a,
              v1: v1a,
              c1: uidgena,
              secret_id:
                encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETID,
              secret_key:
                encryptStorage.getItem("rez_dev_k").VUE_APP_SRCHANA_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let response_data = JSON.parse(response.request.response);
          if (response_data) {
            console.log("get_srchana_iplatlon", response_data);
            this.device_locale = response_data.country_iso;
            vm.getApiData(
              response_data.search_ip,
              response_data.search_lat,
              response_data.search_lon
            );
          }
        });
    },
    usDBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_USD);
      } catch (e) {
        console.error("Failed to parse VUE_APP_USD:", e);
        return [];
      }
    },
    gbPBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_GBP);
      } catch (e) {
        console.error("Failed to parse VUE_APP_GBP:", e);
        return [];
      }
    },
    euRBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_EUR);
      } catch (e) {
        console.error("Failed to parse VUE_APP_EUR:", e);
        return [];
      }
    },
    gaGtmBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_GTM);
      } catch (e) {
        console.error("Failed to parse VUE_APP_GTM:", e);
        return [];
      }
    },
    getApiData(search_ip, search_lat, search_lon) {
      let search_results_button_click = encryptStorage.getItem(
        "search_results_button_click"
      );
      if (typeof search_results_button_click !== "undefined") {
        if (search_results_button_click == "1") {
          sessionStorage.removeItem("cart");
          encryptStorage.removeItem("orefwithoutprefix");
          encryptStorage.removeItem("dis_cpk");
          encryptStorage.removeItem("dis_ftt");
          encryptStorage.removeItem("discount_amount");
          encryptStorage.removeItem("discount_amount_applied");
          encryptStorage.removeItem("discount_coupon_applied");
          encryptStorage.setItem("search_results_button_click", "0");
        }
      }

      let data = {
        brand_id: this.setbrandid,
        venue_id: this.venue_select,
        valid_from: this.date1_date,
        valid_till: this.date2_date,
        start_time: this.date1_time,
        end_time: this.date2_time,
        partner_id: this.partner_id,
        partner_name: this.$cookie.getCookie("utm_partner"),
        campaign_id: this.campaign_id,
        campaign_name: this.$cookie.getCookie("utm_campaign"),
        search_origin: this.search_origin,
        venue_name: this.venue_select_name,
        search_ip: search_ip,
        search_lat: search_lat,
        search_lon: search_lon,
        slots_to_book: 1,
        tracking_id: this.gensessionid(),
        utm_campaign: this.$cookie.getCookie("utm_campaign"),
        utm_content: this.$cookie.getCookie("utm_content"),
        utm_medium: this.$cookie.getCookie("utm_medium"),
        utm_partner: this.$cookie.getCookie("utm_partner"),
        utm_source: this.$cookie.getCookie("utm_source"),
        utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
        utm_term: this.$cookie.getCookie("utm_term"),
        device_type: this.device_type,
        device_browser: this.device_browser,
        device_locale: this.device_locale,
        device_os: this.device_os,
        device_resolution: this.getResolution(),
      };
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_SLOTSVIEW_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_SLOTSVIEW_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + (
            this.partner_id
              ? "partners/frontend/parking/search"
              : "parking/frontend/carpark/slots/view"
          ),
          data,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then(
          (response) => {
            // console.log("getApiData response", response);

            let datasent = JSON.parse(response.request.response);

        if (datasent.user_exists === "N" && datasent.error_code === 103) {
          //alert("User does not exist. Please check your details and try again."); 
          this.dataloaded_carparkdetails = false;
          this.dataloaded = true;
          this.advanced_search_error = datasent.data;
          if (this.advanced_search_error) {
            this.advanced_search_error = this.getrans(datasent.data); 
          }
          if (this.advanced_search_error && datasent.extra_value) {
            this.advanced_search_error = 
              this.advanced_search_error.replaceAll("~extra_value~", datasent.extra_value)
          }
          return;
        }

            this.searchres = datasent.data;
            console.log("getApiData response", datasent.data);
            if (this.searchres === "No Slots Available") {
              this.noSlotsAvailable = true;
              this.sendNoSlotsAnalytics(data);
            }

            let datalayerparams = {};
            let datalayeritems = [];
            datalayerparams.entry_date = this.formatDateymd_dashed(
              this.date1_date
            );
            datalayerparams.entry_time = this.date1_time;
            datalayerparams.exit_date = this.formatDateymd_dashed(
              this.date2_date
            );
            datalayerparams.exit_time = this.date2_time;

            let ecom = {};
            let tot = 0;
            for (let j = 0; j < this.searchres.length; j++) {
              let items = {};
              items.item_id = this.searchres[j].product_id;
              items.item_name = this.searchres[j].product_display_name;
              console.log("this.searchres[j].grand_total", this.searchres[j]);
              let prp;
              if (typeof this.searchres[j].grand_total === "string") {
                prp = this.searchres[j].grand_total;
              } else if (this.searchres[j].grand_total !== undefined && this.searchres[j].grand_total !== null) {
                prp = this.searchres[j].grand_total.toFixed(2);
              } else {
                prp = "0.00";
              }
              items.price = parseFloat(prp);
              items.item_list_id = this.setbrandid.toLowerCase() + "_cpk_list";
              items.item_list_name =
                this.setbrandid.toUpperCase() + " Carpark Search Result List";
              tot = tot + parseFloat(this.searchres[j].grand_total);
              datalayeritems.push(items);
            }
            ecom.item_list_id = this.setbrandid.toLowerCase() + "_cpk_list";
            ecom.item_list_name =
              this.setbrandid.toUpperCase() + " Carpark Search Result List";
            if (this.usDBrands().indexOf(this.setbrandid) > -1) {
              ecom.currency = "USD";
            }
            if (this.euRBrands().indexOf(this.setbrandid) > -1) {
              ecom.currency = "EUR";
            }
            if (this.gbPBrands().indexOf(this.setbrandid) > -1) {
              ecom.currency = "GBP";
            }
            if (this.setbrandid === "PV1") {
              ecom.send_to = "AW-16447517358/Wt3nCJX9vZcZEK7l5KI9";
            }

            ecom.value = parseFloat(tot.toFixed(2));
            ecom.items = datalayeritems;
            datalayerparams.ecommerce = ecom;
            let testar = [];
            testar.push({
              event: "view_item_list",
              ...datalayerparams,
            });
            console.info("testar", testar);

            if (this.gaGtmBrands().indexOf(this.setbrandid) > -1) {
              /* eslint-disable */
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({ ecommerce: null });
              dataLayer.push({
                event: "view_item_list",
                ...datalayerparams,
              });
              /* eslint-enable */
            }

            //console.log("searchres", '"' + this.searchres + '"');
            this.dataloaded = true;
            this.setListOrder(this.closeest_cheapest);
            this.neworder_key++;

            setTimeout(() => {
              //this.onAirlineSelectChange();
              //this.onTerminalSelectChange();
              //this.onProductSelectChange();
              if (this.$refs[`airline_select`]) {
                this.$refs[`airline_select`].dispatchEvent(
                  new Event("change", { bubbles: true })
                );
              }
              // if (!this.$refs[`terminal_select`]) return;
              // this.$refs[`terminal_select`].dispatchEvent(
              //   new Event("change", { bubbles: true })
              // );
            }, 0);

            let dataa = { brand_id: this.setbrandid };
            let secsaa = genkeys(
              encryptStorage.getItem("rez_dev_k").VUE_APP_CPKDET_SECRETID,
              encryptStorage.getItem("rez_dev_k").VUE_APP_CPKDET_SECRETKEY
            );
            let b1sa = secsaa.b1s;
            let v2sa = secsaa.v2s;
            let a1a = secsaa.a1;
            let v1a = secsaa.v1;
            let c2sa = secsaa.c2s;
            let uidgena = secsaa.uidgen;
            let data_endpoint_products =
              "hubapmydbauth/parkingproducts/parkingproductdetailslive.php";
            axios
              .post(
                encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
                  "hubapmydbauth/carparkingservice/carparkdetailslive.php",
                dataa,
                {
                  headers: {
                    b1: b1sa,
                    v2: v2sa,
                    c2s: c2sa,
                    a1: a1a,
                    v1: v1a,
                    c1: uidgena,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((response) => {
                let datasent = JSON.parse(response.request.response);
                this.carparkdetails = datasent;
                axios
                  .post(
                    encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
                      data_endpoint_products,
                    dataa,
                    {
                      headers: {
                        b1: b1sa,
                        v2: v2sa,
                        c2s: c2sa,
                        a1: a1a,
                        v1: v1a,
                        c1: uidgena,
                        "Content-Type": "application/json",
                      },
                    }
                  )
                  .then((response) => {
                    let datasent = JSON.parse(response.request.response);
                    this.parkingproductdetails = datasent;
                    // console.log("carparkdetails", this.carparkdetails);
                    //alert('3333333');
                    this.dataloaded_carparkdetails = true;
                    this.setListOrder(this.closeest_cheapest);
                    this.neworder_key++;

                    setTimeout(() => {
                      if (this.$refs[`airline_select`]) {
                        this.$refs[`airline_select`].dispatchEvent(
                          new Event("change", { bubbles: true })
                        );
                      }
                    }, 0);

                    this.set_min_max_prices();
                    this.get_prices_array();
                  });
              });
          },
          (error) => {
            console.log("searchres error", error);
          }
        );
      setTimeout(() => {
        this.widgetloaded = true;
        //sessionStorage.clear();
      }, 0);
    },

    getbranded() {
      var thingy = this;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/gtbrnslg.php",
          "",
          {
            headers: {
              secret_id:
                encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key:
                encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // console.log(response.data.slug);
          //console.log(response.data.currency);
          if (response.data.code == "1") {
            thingy.setbrandid = response.data.slug;
            thingy.currency = response.data.currency;
            if (
              response.data.slug == "HER" ||
              response.data.slug == "NOC" ||
              response.data.slug == "SZG" ||
              response.data.slug == "PB1"
            ) {
              thingy.currency = "€";
            }
            thingy.brandloaded = true;
            thingy.loadTranslations();
            thingy.getBrandData();
            thingy.get_srchana_iplatlon();
            thingy.$proxyCheck();
            thingy.set_results_subheadline();
            thingy.getinitialvalue();
            this.utmdata(response.data.slug);

            if (response.data.slug == "HER") {
              let combined_venue_name =
                this.venue_select_name.trim() + " " + "Airport Parking";
              combined_venue_name = combined_venue_name.trim();
              this.results_headline = this.getrans(combined_venue_name);
            }
            if (response.data.slug == "RDU") {
              let combined_venue_name =
                this.venue_select_name.trim() + " " + " Parking";
              combined_venue_name = combined_venue_name.trim();
              this.results_headline = this.getrans(combined_venue_name);
            }
            if (response.data.slug == "PV1") {
              let combined_venue_name =
                this.venue_select_name.trim() + " " + " Parking";
              combined_venue_name = combined_venue_name.trim();
              this.results_headline = this.getrans(combined_venue_name);
            }

            if (response.data.slug == "SV1") {
              this.results_headline = this.getrans("Airport Parking");
            }

            if (response.data.slug == "HVN") {
              this.results_headline = this.getrans("HVN Reserve");
            }

            if (response.data.slug == "PIT") {
              this.results_headline = this.getrans(
                "Airport Parking Reservation"
              );
              this.book_button_text = this.getrans("RESERVE NOW");
            }
            if (response.data.slug == "ML1") {
              this.results_headline = this.getrans(
                "Official Ocean Village Car Parking"
              );
            }
            if (response.data.slug == "PB1") {
              this.results_headline = this.getrans("PBW Parking");
            }
            if (response.data.slug === "LAX") {
              this.result_selected_style = "grid";
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.has("log_key")) {
              this.dew_log(urlParams.get("log_key"));
              }              
            }
            if (response.data.slug === "SZG") {
              this.result_selected_style = "grid";
            }

            this.new_results = "standard";

            if (
              response.data.slug == "NWI" ||
              response.data.slug == "HER" ||
              response.data.slug == "RDU"
            ) {
              this.new_results = false;
            }
            if (
              response.data.slug == "LAX"
              // || response.data.slug == "AIR"
            ) {
              this.new_results = "condensed";
            }

            if (this.setbrandid === 'LAX' || this.setbrandid === 'HER') {
              this.auto_remember_device_pci();
            }

            this.verify_fees_prebook();
            this.getComponents();
          }
          else {
            this.siteDown = "We apologise for the inconvenience, we'll be back online shortly.";
            this.siteDownMsg = true;
          }
          this.sendToDataLayer();
        });
    },
    verify_fees_prebook() {
      let dsa_date_string = "";
      if (
        this.setbrandid == "RDU" ||
        this.setbrandid == "YHM" ||
        this.setbrandid == "OKC" ||
        this.setbrandid == "LAX" ||
        this.setbrandid == "DEN" ||
        this.setbrandid == "SAT" ||
        this.setbrandid == "PV1" ||
        this.setbrandid == "SV1" ||
        this.setbrandid == "PIT" ||
        this.setbrandid == "HVN" ||
        this.setbrandid == "AB1"
      ) {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "US/Eastern",
        });
      }
      if (this.setbrandid == "NUE") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/Berlin",
        });
      }
      if (this.setbrandid == "HER") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Nicosia",
        });
      }
      if (
        this.setbrandid == "NWI" ||
        this.setbrandid == "AIR" ||
        this.setbrandid == "NQY" ||
        this.setbrandid == "NOC" ||
        this.setbrandid == "IP1" ||
        this.setbrandid == "BHX" ||
        this.setbrandid == "BH2"
      ) {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      if (this.setbrandid == "AUH") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Dubai",
        });
      }
      dsa_date_string = dsa_date_string.split(",");
      let datepart_str = dsa_date_string[0].split("/");
      let datenow =
        datepart_str[2] +
        "-" +
        datepart_str[1] +
        "-" +
        datepart_str[0] +
        " " +
        dsa_date_string[1];

      let datacancel = {
        brand_id: this.setbrandid,
        product_id: "cpk",
        venue_id: this.venue_select,
        booking_date_time: datenow,
        entry_date_time:
          this.date1_date.replace(/\//g, "-") + " " + this.date1_time,
        fees_for: "B",
      };

      let secsaaip_all = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_CANAMN_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_CANAMN_SECRETKEY
      );
      let ur = "fees/frontend/config/pre/view";
 
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + ur,
          datacancel,
          {
            headers: {
              b1: secsaaip_all.b1s,
              v2: secsaaip_all.v2s,
              c2s: secsaaip_all.c2s,
              a1: secsaaip_all.a1,
              v1: secsaaip_all.v1,
              c1: secsaaip_all.uidgen,
            },
          }
        )
        .then((response) => {
          let codesent = JSON.parse(response.request.response);
          console.log("verify_fees_prebook", codesent);
          if (codesent.status) {
            let st = codesent.status;
            if (st == "success") {
              let dta = codesent.data;
              if (this.setbrandid == "HVN") {
                let bookingPolicy = null;
                let taxPolicy = null;

                for (let n = 0; n < dta.length; n++) {
                  let item_fee = dta[n];
                  if (item_fee.calculation_type == "B") {
                    bookingPolicy = item_fee;
                  }
                  if (item_fee.calculation_type == "T") {
                    taxPolicy = item_fee;
                  }
                }

                let booking_fee_name = "";
                let booking_fee = 0;
                let applicable_on_sub_products = "";
                let show_on_invoice = "";
                let show_on_website = "";
                let policy_code = "";
                let sub_product_array = [];

                if (bookingPolicy) {
                  show_on_invoice = bookingPolicy.show_on_invoice;
                  booking_fee_name = bookingPolicy.policy_name;
                  policy_code = bookingPolicy.policy_code;
                  show_on_website = bookingPolicy.show_on_website;
                  applicable_on_sub_products =
                    bookingPolicy.applicable_on_sub_products;
                  sub_product_array = bookingPolicy.sub_product_array;
                  if (
                    bookingPolicy.calculation &&
                    bookingPolicy.calculation[0] &&
                    bookingPolicy.calculation[0].calculation_value
                  ) {
                    booking_fee = bookingPolicy.calculation[0].calculation_value;
                  }
                }

                let pfeedetails = {
                  show_on_invoice: show_on_invoice,
                  booking_fee_name: booking_fee_name,
                  policy_code: policy_code,
                  show_on_website: show_on_website,
                  applicable_on_sub_products: applicable_on_sub_products,
                  sub_product_array: sub_product_array,
                  booking_fee: booking_fee,
                  booking_fee_policy: bookingPolicy,
                  tax_policy: taxPolicy,
                  policies: dta,
                };

                encryptStorage.setItem("pfeedetails", pfeedetails);
                encryptStorage.setItem("booking_fee_hidden", booking_fee);
                encryptStorage.setItem(
                  "booking_fee_name_hidden",
                  booking_fee_name
                );
                if (show_on_website == "N") {
                  this.parking_additional_charges = "Y";
                  this.parking_additional_value = booking_fee;
                }
                return;
              }

              let booking_fee_name = "";
              let booking_fee = 0;
              let applicable_on_sub_products = "";
              let show_on_invoice = "";
              let show_on_website = "";
              let policy_code = "";
              let sub_product_array = [];

              for (let n = 0; n < dta.length; n++) {
                let item_fee = dta[n];
                show_on_invoice = item_fee.show_on_invoice;
                booking_fee_name = item_fee.policy_name;
                policy_code = item_fee.policy_code;
                show_on_website = item_fee.show_on_website;
                applicable_on_sub_products =
                  item_fee.applicable_on_sub_products;
                sub_product_array = item_fee.sub_product_array;
                booking_fee = item_fee.calculation[0].calculation_value;
              }
              let pfeedetails = {
                show_on_invoice: show_on_invoice,
                booking_fee_name: booking_fee_name,
                policy_code: policy_code,
                show_on_website: show_on_website,
                applicable_on_sub_products: applicable_on_sub_products,
                sub_product_array: sub_product_array,
                booking_fee: booking_fee,
              };
              encryptStorage.setItem("pfeedetails", pfeedetails);
              encryptStorage.setItem("booking_fee_hidden", booking_fee);
              encryptStorage.setItem(
                "booking_fee_name_hidden",
                booking_fee_name
              );
              if (show_on_website == "N") {
                this.parking_additional_charges = "Y";
                this.parking_additional_value = booking_fee;
              }
            }
          }
        });
    },

    set_results_subheadline() {
      //"11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am";
      if (this.date1_date && this.date2_date) {
        this.results_subheadline =
          this.format_date_with_locale(this.date1_date, "date") +
          " " +
          this.getrans("at") +
          " " +
          this.format_date_with_locale(
            this.date1_date + " " + this.date1_time,
            "time"
          ) +
          " - " +
          this.format_date_with_locale(this.date2_date, "date") +
          " " +
          this.getrans("at") +
          " " +
          this.format_date_with_locale(
            this.date2_date + " " + this.date2_time,
            "time"
          );

        if (this.setbrandid === "SV1") {
          this.results_subheadline = this.results_subheadline.replace(
            /th|rd|st|nd/g,
            ""
          );
        }
        if (
          this.setbrandid === "SZG" ||
          this.setbrandid === "BRE" ||
          this.setbrandid === "PB1"
        ) {
          const formatDate = (date) => {
            const [year, month, day] = date.split(".");
            return `${day}.${month}.${year}`;
          };

          this.results_subheadline =
            formatDate(this.date1_date.replace(/\//g, ".")) +
            " " +
            this.getrans("at") +
            " " +
            this.date1_time +
            " - " +
            formatDate(this.date2_date.replace(/\//g, ".")) +
            " " +
            this.getrans("at") +
            " " +
            this.date2_time;
        }
      }
    },
    getinitialvalue() {
      let vm = this;
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_INIT_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_INIT_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      //console.log("uidgen", uidgen);
      let dd = { brand_id: this.setbrandid };
      console.log("dd", dd);
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "parking/frontend/brand/initial_value",
          dd,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let response_data = JSON.parse(response.request.response);
          if (response_data) {
            console.log("get_initial_value response_data", response_data);

            console.log("airline_list", response_data.data.airline_list);
            if (
              response_data.data.airline_list &&
              response_data.data.airline_list.length
            ) {
              vm.airline_list = response_data.data.airline_list.sort((a, b) =>
                a.airline_name.localeCompare(b.airline_name)
              );
            }

            if (
              response_data.data.terminal_list &&
              response_data.data.terminal_list.length
            ) {
              vm.terminal_list = response_data.data.terminal_list.sort((a, b) =>
                a.terminal_name.localeCompare(b.terminal_name)
              );
            }

            if (
              response_data.data.featured_product &&
              response_data.data.featured_product.length
            ) {
              vm.featured_product = response_data.data.featured_product;
              vm.featured_product = vm.featured_product.sort((a, b) =>
                a.product_name.localeCompare(b.product_name)
              );
            }

            if (
              response_data.data.product_feature_list &&
              response_data.data.product_feature_list.length
            ) {
              //vm.product_list = response_data.data.product_feature_list;
              //console.log('response_data.data.product_feature_list', response_data.data.product_feature_list);
              vm.product_list = response_data.data.product_feature_list.sort(
                (a, b) =>
                  a.product_feature_name.localeCompare(b.product_feature_name)
              );
            }

            if (response_data.data.widget_config.select_terminal === true) {
              if (response_data.data.terminal_list) {
                vm.terminal_list = response_data.data.terminal_list;
                if (
                  vm.terminal_select === null &&
                  vm.terminal_list.length > 0
                ) {
                  //const urlParams = new URLSearchParams(window.location.search);
                  //vm.terminal_select = urlParams.get("terminal_select");
                  setTimeout(() => {
                    if (!this.$refs[`terminal_select`]) return;
                    this.$refs[`terminal_select`].dispatchEvent(
                      new Event("change", { bubbles: true })
                    );
                  }, 0);
                }
              }
            }
          }
          /* eslint-disable */
        });
    },
    utmdata(brandslug) {
      let sessid = "";
      let analytics = "0";
      if (!this.$cookie.isCookieAvailable("session-id")) {
        this.gensessionid();
        sessid = encryptStorage.getItem("search_analytics_id");
      } else {
        sessid = this.$cookie.getCookie("session-id");
        analytics = "1";
      }
      if (this.$cookie.isCookieAvailable("utm_partner")) {
        let trackevents = { page: window.location.href, analytics: analytics };
        let tdata = {
          utm_campaign: this.$cookie.getCookie("utm_campaign"),
          utm_content: this.$cookie.getCookie("utm_content"),
          utm_medium: this.$cookie.getCookie("utm_medium"),
          utm_partner: this.$cookie.getCookie("utm_partner"),
          utm_source: this.$cookie.getCookie("utm_source"),
          utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
          utm_term: this.$cookie.getCookie("utm_term"),
          session_id: sessid,
          trackevents: trackevents,
          brandslug: brandslug,
        };

        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_UTM_CAMPAIGN_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_UTM_CAMPAIGN_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/utm_campaign/camplive.php",
            tdata,
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log("utmdata", response.data);
          });
      }
    },
    formatDateymd_dashed(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    sendToDataLayer() {
      if (this.gaGtmBrands().indexOf(this.setbrandid) > -1) {
        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "booking_search",
          params: {
            search_term: "parking",
            entry_date: this.formatDateymd_dashed(this.date1_date),
            exit_date: this.formatDateymd_dashed(this.date2_date),
            entry_time: this.date1_time,
            exit_time: this.date2_time,
            venue: this.venue_select_name,
          },
        });
        /* eslint-enable */
      }
    },
    getResolution() {
      // const realWidth = window.screen.width * window.devicePixelRatio;
      //const realHeight = window.screen.height * window.devicePixelRatio;
      const realWidth = window.screen.width;
      const realHeight = window.screen.height;
      return `${realWidth} x ${realHeight}`;
    },
    sendNoSlotsAnalytics(searchData) {
      // Convert date format from YYYY/MM/DD to YYYY-MM-DD
      if (searchData.valid_from) {
        searchData.valid_from = searchData.valid_from.replace(/\//g, '-');
      }
      if (searchData.valid_till) {
        searchData.valid_till = searchData.valid_till.replace(/\//g, '-');
      }

      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_UTM_CAMPAIGN_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_UTM_CAMPAIGN_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;

      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/utm_campaign/noslots.php",
          searchData,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("No slots analytics sent", response.data);
        })
        .catch((error) => {
          console.error("Failed to send no slots analytics", error);
        });
    },
    async get_rez_data_k() {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") {
        let _this = this;
        await axios
          .get("https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php")
          .then((response) => {
            const key = "XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn";
            const encryptedData = response.data;
            let dec = _this.decrypt_custom(key, encryptedData);
            console.log("rez_dev_k", dec);
            encryptStorage.setItem("rez_dev_k", dec);
          })
          .then(() => {
            _this.getbranded();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.getbranded();
      }
    },
    decrypt_custom(key, data) {
      const decodedData = Buffer.from(data, "base64").toString("utf8");
      const parts = decodedData.split("::");

      // Extract IV
      key = Buffer.from(parts[0]);
      let iv = Buffer.from(parts[2], "hex");

      // Extract encrypted data
      const encryptedData = Buffer.from(parts[1], "base64");

      // Create decipher object with correct IV and key
      const decipher = crypto.createDecipheriv("aes-256-cbc", key, iv);

      // Update decryption with encrypted data
      let decrypted = decipher.update(encryptedData);

      // Finalize the decryption
      decrypted = Buffer.concat([decrypted, decipher.final()]);

      return decrypted.toString("utf8");
    },

    // PCI Compliant RememberDevice Methods
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    },

    async auto_remember_device_pci() {
      try {
        const cookie = this.getCookie('remember_device');
        if (!cookie) return;
        
        const decoded = window.atob(cookie);
        const deviceData = JSON.parse(decoded);
        const deviceId = deviceData.deviceId;
        
        const checkResponse = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/rem.php', {
          action: 'remember-device-check',
          brand_id: this.setbrandid,
          deviceId: deviceId
        }, {
          withCredentials: true
        });
        
        if (checkResponse.data.remembered) {
          this.remember_device_autologin(deviceId);
        }
      } catch (error) {
        console.error('Auto-login check error:', error);
      }
    },

    remember_device_autologin(deviceId) {
      axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/rem.php', {
        action: 'remember-device-login',
        brand_id: this.setbrandid,
        deviceId: deviceId
      }, {
        withCredentials: true
      })
      .then((response) => {
        if (response.data.success && response.data.userdata && response.data.sessionId) {
          const userdata = response.data.userdata;
          const newSessionId = response.data.sessionId;
          
          // Update sessionId for PCI compliance - user is now logged in
          if (typeof sessionManager !== 'undefined' && sessionManager.updateSession) {
            sessionManager.updateSession(newSessionId);
          }
          
          encryptStorage.setItem("session_userdata", userdata);
          if (this.setLocalData && typeof this.setLocalData === 'function') {
            this.setLocalData(
              "accessToken",
              Date.now().toString(36) + Math.random().toString(36).substr(2)
            );
            this.setLocalData(
              "refreshToken",
              Date.now().toString(36) + Math.random().toString(36).substr(2)
            );
            this.setLocalData("emailEntered", userdata.email);
            this.setLocalData("lastLogin", Date.now());
          }
          this.updateHeader++;
        }
      })
      .catch((error) => {
        console.error('Auto-login error:', error);
      });
    },
    dew_log(log_key) {
      // Add request ID for tracking and replay protection
      const requestId =
        Date.now().toString(36) + Math.random().toString(36).substr(2);

      // Validate log_key to prevent injection
      if (!log_key || typeof log_key !== "string" || log_key.length > 100) {
        console.error("Invalid log key");
        return;
      }

      let datasearch = {
        brand_id: this.setbrandid.toLowerCase(),
        transaction_token: log_key,
        timestamp: Date.now(), // Add timestamp for request freshness
      };

      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
      );
      let ur = "hubapmydbauth/live_alog/dew.php";
 
      axios
        .post(encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB + ur, datasearch, {
          headers: {
            b1: secsa.b1s,
            v2: secsa.v2s,
            c2s: secsa.c2s,
            a1: secsa.a1,
            v1: secsa.v1,
            c1: secsa.uidgen,
            "Content-Type": "application/json",
            "X-Request-ID": requestId,
          },
        })
        .then((response) => {
          // Validate response
          if (!response || !response.data) {
            console.error("Invalid response from server");
            return;
          }

          let data = response.data;
          if (data.user_exists == "Y" && data.data) {
            let uuid = data.data;

            if (!uuid) {
              return;
            }

            this.setLocalData("uuid", uuid);
            let datasearch = {
              slug: this.setbrandid,
              uid: uuid,
            };

            // Get appropriate keys based on brand
            let secsaa = {};
            if (this.setbrandid == "HER") {
              secsaa = genkeys(
                encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETID_FRA,
                encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETKEY_FRA
              );
              ur = encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS_FRA;
            } else {
              secsaa = genkeys(
                encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETID,
                encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETKEY
              );
              ur = encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO_LDN;
            }

            // Add request ID for this request too
            const userDetailsRequestId =
              Date.now().toString(36) + Math.random().toString(36).substr(2);

            axios
              .post(ur + "ssouser/", datasearch, {
                headers: {
                  b1: secsaa.b1s,
                  v2: secsaa.v2s,
                  c2s: secsaa.c2s,
                  a1: secsaa.a1,
                  v1: secsaa.v1,
                  c1: secsaa.uidgen,
                  "X-Request-ID": userDetailsRequestId,
                },
              })
              .then(
                (response) => {
                  // Validate response
                  if (!response || !response.data) {
                    console.error("Invalid user details response");
                    return;
                  }

                  let userdatasent = response.data;
                  if (
                    userdatasent.user_exists == "Y" &&
                    userdatasent.result &&
                    userdatasent.result.length > 0
                  ) {
                    sessionStorage.setItem("session_uuid", uuid);
                    let userdata = userdatasent.result[0];
                    encryptStorage.setItem("session_userdata", userdata);
                    this.updateHeader++;
                  }
                },
                (error) => {
                  console.error("Error fetching user details", error);
                }
              );
          }
        })
        .catch((error) => {
          console.error("Authentication error", error);
        });
    },
  },
  created() {},
  watch: {
    airline_select() {
      sessionStorage.setItem('airline_select', this.airline_select);
      //if airline_select in url parameters, update the URL
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set("airline_select", this.airline_select);
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    },
  },
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById("loader");
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
    this.get_rez_data_k();
    const uap = new window.UAParser();
    const uatdata = uap.getResult();
    if (
      uatdata.device.type === undefined ||
      !["wearable", "mobile"].includes(uatdata.device.type)
    ) {
      uatdata.device.type = "desktop";
    }
    this.device_type = uatdata.device.type;
    this.device_os = uatdata.os.name;
    this.device_browser = uatdata.browser.name;

    if (this.$cookie.getCookie('partner_id')) {
      this.partner_id = this.$cookie.getCookie('partner_id');
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.date1_date = urlParams.get("date1_date");
    this.date1_time = urlParams.get("date1_time");
    this.date2_date = urlParams.get("date2_date");
    this.date2_time = urlParams.get("date2_time");
    this.venue_select = urlParams.get("venue_select");
    this.setLocalData("venue_selected_cpk", this.venue_select);
    this.venue_select_name = urlParams.get("venue_select_name");
    this.setLocalData("venue_selected", this.venue_select);
    this.setLocalData("venue_selected_name_cpk", this.venue_select_name);
    if (urlParams.has("utm_partner")) {
      this.utm_partner = urlParams.get("utm_partner");
      this.$cookie.setCookie("utm_partner", this.utm_partner);
    }
    if (urlParams.has("utm_medium")) {
      this.utm_medium = urlParams.get("utm_medium");
      this.$cookie.setCookie("utm_medium", this.utm_medium);
    }
    if (urlParams.has("utm_content")) {
      this.utm_content = urlParams.get("utm_content");
      this.$cookie.setCookie("utm_content", this.utm_content);
    }
    if (urlParams.has("utm_campaign")) {
      this.utm_campaign = urlParams.get("utm_campaign");
      this.$cookie.setCookie("utm_campaign", this.utm_campaign);
    }
    if (urlParams.has("utm_source")) {
      this.utm_source = urlParams.get("utm_source");
      this.$cookie.setCookie("utm_source", this.utm_source);
    }
    if (urlParams.has("utm_sub_partner")) {
      this.utm_sub_partner = urlParams.get("utm_sub_partner");
      this.$cookie.setCookie("utm_sub_partner", this.utm_sub_partner);
    }
    if (urlParams.has("utm_term")) {
      this.utm_term = urlParams.get("utm_term");
      this.$cookie.setCookie("utm_term", this.utm_term);
    }
    if (urlParams.has("airline_select")) {
      this.airline_select = urlParams.get("airline_select");
      if (this.airline_select == 0) {
        this.airline_select = "All";
        this.sort_dropdown = "featured";
      }
    }
    else if (sessionStorage.getItem('airline_select_booked')) {
      this.airline_select = sessionStorage.getItem('airline_select_booked');
      if (this.airline_select == 0) {
        this.sort_dropdown = "featured";
      }
    } else {
      this.sort_dropdown = "featured";
    }
    if (urlParams.has("search_origin")) {
      this.search_origin = urlParams.get("search_origin");
      this.$cookie.setCookie("search_origin", this.search_origin);
    }

    if (this.date1_date) {
      this.date1_date = new Date(this.correctdate(this.date1_date));
      this.date1_date = this.formatDateymd(this.date1_date);
      this.date2_date = new Date(this.correctdate(this.date2_date));
      this.date2_date = this.formatDateymd(this.date2_date);

      this.date1_forwidget =
        this.correctdate(urlParams.get("date1_date")) +
        " " +
        urlParams.get("date1_time");
      this.date2_forwidget =
        this.correctdate(urlParams.get("date2_date")) +
        " " +
        urlParams.get("date2_time");
    }

    if (localStorage.getItem("preferred_results_view")) {
      this.setListStyle(localStorage.getItem("preferred_results_view"));
    }

    // console.log("this.date1_date", this.date1_date);
    // console.log("this.date1_time", this.date1_time);
    // console.log("this.date2_date", this.date2_date);
    // console.log("this.date2_time", this.date2_time);

    window.addEventListener(
      "search_results_button_click",
      (event) => {
        encryptStorage.setItem("search_results_button_click", "1");
        console.log("search_results_button_click got it", event.detail.data);
      },
      false
    );

    setTimeout(() => {
      this.widgetloaded = true;
      //this.getBrandData();
      //sessionStorage.clear();

      
        // setTimeout(() => {

        //   if (this.setbrandid === "NOC") {

        //     Swal.fire({
        //         html: `<div style="text-align: left;">Due to server maintenance and update works on our Number Plate Recognition system, customers who have booked online parking and are arriving at the airport and exiting the airport between Thursday, 5th February and Monday, 9th February, are advised to follow these steps: <br> <br>
        //       On arrival: <br>
        //       <br>
        //       Drive up to the barrier and take a ticket from the machine, even if you have already booked online.<br>
        //       <br>
        //       On your return: <br>
        //       <br>
        //       On arrival back to the airport, before you exit the car park, please go to our Security Office, have your online booking reference to hand, and our staff will assist with exit <br>
        //       <br>
        //       Alternatively, passengers are advised to have their online parking confirmation booking/reference number to hand for presenting at the exit gate, where staff will be on hand to assist with exit.<br>
        //       <br>
        //       We apologise for any inconvenience caused.</div>`,
        //         confirmButtonText: "Close",
        //         showCloseButton: true,
        //       });
        //     }

        //   }, 200);

    }, 0);
    //console.log("this.venue_select");
    //console.log(this.venue_select);



  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/calenderOverride.scss";
@import "@/assets/sass/override_brand.scss";
@import "@/assets/sass/swalOverride.scss";

// .tab-basket {
//   display: none !important;
// }
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.hero-section {
  height: auto;
  background: $indexpage-hero-bg;

  .hero-bg-mobile {
    @media screen and (max-width: 767px) {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        var(--hero-background-mobile);
      background-size: cover;
      height: auto;
      position: relative;
      width: 100%;
      z-index: 0;
    }
  }

  .hero-bg-desktop {
    @media screen and (min-width: 768px) {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
        var(--hero-background-desktop);
      background-size: cover;
      background-repeat: no-repeat;
      background-position-x: center;
      background-position-y: center;
      max-height: $indexpage-hero-height;
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 0;
    }
  }

  .hero-text {
    position: relative;
    margin: 0 auto;
    max-width: 1260px;
    text-align: var(--hero-text-align-mobile);
    padding: 15px 15px;
    box-sizing: border-box;
    color: $indexpage-hero-text;
    text-shadow: $indexpage-hero-text-shadow;

    @media screen and (min-width: 768px) {
      text-align: var(--hero-text-align);
    }

    h1 {
      font-family: $indexpage-hero-font-h1;
      font-size: var(--hero-font-size-h1-mobile);
      @media screen and (min-width: 768px) {
        font-size: var(--hero-font-size-h1);
      }
    }
    p {
      font-family: $indexpage-hero-font-p;
      font-size: var(--hero-font-size-p-mobile);
      @media screen and (min-width: 768px) {
        font-size: var(--hero-font-size-p);
      }
    }
    h1,
    p {
      margin: 10px 0px;
      @media screen and (min-width: 768px) {
        margin: 10px;
      }
    }
    @media screen and (min-width: 768px) {
      padding: 50px 30px;
    }
  }
}

.panel-group-container {
  background-color: var(--panel-background-color);
  margin-top: 2rem;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }

  .panel-group {
    position: relative;
    max-width: 1260px;
    margin: 0 auto;
    padding: 3rem 0;
  }
}

.results-banner-container {
  padding: 2rem 0 1rem;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 1rem 1rem;
  }
}

.results {
  &-filter {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-container {
      height: 54px;
      background-color: #f9f9f9;
      border-bottom: 2px solid var(--header_banner_search_filter_color, #034a94);

      @media screen and (max-width: 768px) {
        display: none;
      }

      a {
        display: inline-block;
        line-height: 52px;
        border: none;
        padding: 0 1.625rem;
        margin: 0;
        background-color: transparent;
        border-right: 1px solid #dfdfdf;
        text-decoration: none;
        color: #000000;

        &:first-child {
          border-left: 1px solid #dfdfdf;
        }

        &:hover,
        &:active,
        &.active {
          background-color: var(--header_banner_search_filter_color, #034a94);
          color: #ffffff;
        }
      }

      button {
        display: inline-block;
        line-height: 52px;
        border: none;
        padding: 0 1.625rem;
        margin: 0;
        background-color: transparent;
        border-right: 1px solid #dfdfdf;
        text-decoration: none;
        color: #000000;

        &:first-child {
          border-left: 1px solid #dfdfdf;
        }

        &:hover,
        &:active,
        &.active {
          background-color: var(--header_banner_search_filter_color, #034a94);
          color: #ffffff;
        }
      }
    }
  }

  &-container {
    margin-top: 2.75rem;
    // @media screen and (max-width: 768px) {
    //   margin-top: 1rem;
    // }
  }

  &-grid {
    max-width: 1280px;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    @media screen and (max-width: 1024px) {
      grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &-list {
    max-width: calc(1280px + 2rem);
    padding: 0 1rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &-mobile {
    display: none;
    margin: 0 auto;
    display: none;
    @media screen and (max-width: 768px) {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
}

.search-widget-desktop {
  left: 0px;
  position: absolute;
  right: 0px;
  max-width: 1280px;
  margin: 0 auto;
}

.banner-filters {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  @media screen and (min-width: 768px) {
    justify-content: flex-end;
  }

  &__close-cheap,
  &__list-map-view,
  &__edit-search {
    background: #e9e7e7;
    color: #0a3b74;
    box-shadow: 0 3px 6px #00000029;
    padding: 0.5rem 0.3rem;
    font-size: 0.75rem;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    flex-grow: 1;
    @media screen and (min-width: 768px) {
      flex-grow: 0;
    }
  }

  &__close-cheap {
    display: var(--results_sort_filters, initial);
    @media screen and (min-width: 768px) {
      display: none;
    }
  }

  &__list-map-view {
    display: initial;
    @media screen and (min-width: 768px) {
      display: none;
    }
  }

  &__edit-search {
    @media screen and (min-width: 768px) {
      margin-top: -4rem;
      margin-bottom: 2.25rem;
      padding: 0.5rem 3rem;
      font-size: 1rem;
    }
  }
}

.loading-results {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.275rem;
  color: #555;
  &-left {
    padding: 1rem;
    align-items: flex-start;
    flex-direction: column;
    text-align: left;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
  }
}

.proceed-to-checkout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 2rem 3rem;
  max-width: calc(1280px + 2rem);
  margin: 0 auto;
  @media screen and (min-width: 768px) {
    justify-content: flex-end;
  }
  button {
    background-color: #034a94;
    color: #ffffff;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 8px;
    border: none;
    padding: 1.5rem 3.5rem;
    font-size: 1.325rem;
    font-weight: bold;
  }
}

.results-filter__order {
  display: var(--results_sort_filters, initial);
}

.filter_select {
  padding: 0.5rem;
  margin-left: 1rem;
}

.search-filters {
  // border: 1px solid red;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  padding: 0.3rem;
  &-inner {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    > * {
      flex: 4;
      border-radius: 4px;
      padding: 1rem;
      margin: 0;
    }
    > button {
      flex: auto;
      line-height: 1.5;
      padding: 0.5rem;
      color: var(--header_font_color, #384048);
      font-family: var(--header_font_family, Helvetica, Arial, sans-serif);
      border: none;
    }
  }
}
@media screen and (max-width: 768px) {
  .search-filters-inner {
    flex-direction: column;
  }
}

.has-results-filters.has-results-filters {
  height: auto;
  color: var(--header_font_color, #384048);
  background: var(--header_background_color, #fff);
  border-bottom: none;
}

@media screen and (max-width: 768px) {
  .results-filter-container.has-results-filters {
    display: flex;
    flex-direction: column;
  }
}

.search-pills {
  // border: 1px solid red;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  padding: 2rem 0.3rem 0;
  &-inner {
    width: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
  }

  .pill {
    padding: 0.5rem 1rem;
    border: 2px solid#555;
    color: #555;
    border-radius: 5rem;
    font-weight: normal;
    i {
      cursor: pointer;
    }
  }

  .view-buttons {
    border-radius: 100px;
    background: #eeeeee;
    padding: 0.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
    button:hover,
    button {
      padding: 0.5rem 0.8rem;
      border-radius: 100px;
      background: #ffffff00;
      border: none;
      height: auto;
      display: flex;
    }
    button.active:hover,
    button.active {
      background: #ffffffff;
      border: none;
      outline: 2px solid#555;
    }
  }

  .sort-dropdown {
    label {
      margin: 0.25rem 0.5rem;
    }
    select {
      border-radius: 100px;
      padding: 0.5rem 1.5rem 0.5rem 0.5rem;
      border: 2px solid#555;
      line-height: 1.5;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      /* Custom arrow (using an inline SVG) */
      color: #000;
      background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%2010%207%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M0%200l5%207%205-7z%22%20fill%3D%22%23666%22/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 0.5em center;
    }
  }

  @media screen and (max-width: 768px) {
    .view-buttons {
      visibility: hidden;
      display: none;
    }
  }
}

option:disabled {
  color: #aaa;
}

.filter_select_wrap {
  background: #fff;
  display: flex;
  padding: 0;
  justify-content: space-between;
  align-items: center;
  .filter_select {
    border: none;
    margin: 0;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* Custom arrow (using an inline SVG) */
    color: #000;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%2010%207%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M0%200l5%207%205-7z%22%20fill%3D%22%23666%22/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0.5em center;
  }
  i {
    padding: 1rem;
    cursor: pointer;
    color: #000;
  }
}


.keys-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1rem 0rem;
  .keys {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    max-width: 1280px;
    width: 100%;
    gap: 2rem;
    font-size: 1rem;
    svg,
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  @media screen and (max-width: 769px) {
    .keys {
      font-size: 0.8rem;
      gap: 0.5rem;
      svg,
      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }
}

.results-filter-container .slide-up-down__container {
  @media screen and (min-width: 769px) {
    height: auto !important;
  }
}

.filters-button {
  display: none;
  @media screen and (max-width: 767px) {
    display: initial;
  }
}

.faqs-toggles .slide-toggler-wrapper:nth-child(1) {
  border-top: 1px solid #ddd;
}

.faqs-toggles .slide-up-down__container {
  border-top: 1px solid #ddd;
}

.faqs-toggles .slide-toggler-wrapper {
  --widget_padding: 0rem;
  padding: 0rem;
  .v-search-wrapper {
    margin: 0;
    padding: 0 1rem 2rem;
  }

  background: #fff;
  // border: 1px solid #ddd;
  // box-shadow: 0 3px 6px rgb(0 0 0 / 16%) !important;
  // border-bottom: 1px solid #ddd;
  margin-bottom: 0rem;

  .slide-toggler {
    width: 100%;
    padding: 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      transition: 0.2s ease-in-out;
      transform: rotate(0deg);
    }
    .slide-toggler-text {
      display: flex;
      align-items: center;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 0.25rem;
      text-align: left;
      * {
        margin: 0;
        padding: 0;
        font-size: 0.8rem;
        font-family: var(--details_headings_font_family, inherit);
      }
      h3 {
        font-weight: var(--details_headings_font_weight, bold);
        color: var(--details_headings_font_color, #0a3b74);
        font-size: var(--details_headings_font_size, 1.25rem);
      }
    }
  }
  .slide-toggler.slide-toggler-active {
    i {
      transform: rotate(90deg);
    }
  }
}

.faqs-toggles {
  margin: 4rem auto;
  max-width: calc(1280px + 2rem);
  padding: 1rem;
}

.faq-content {
  padding: 2rem 1rem;
}

.new-results-filter-container {
  max-width: calc(1280px + 2rem);
  margin: -1rem auto;

  .new-results-filter-inner {
    margin: 0 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 3px 6px #00000029;

    .keys {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      gap: 1rem;
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
      color: #555;
      svg,
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }

  .filter-toggles {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1;
    user-select: none;
  }

  .slide-toggler-wrapper {
    width: 100%;
  }

  .slide-toggler {
    width: 100%;
    padding: 0.5rem 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    i {
      transition: 0.2s ease-in-out;
      transform: rotate(0deg);
    }
    .slide-toggler-text {
      display: flex;
      align-items: center;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 0.25rem;
      text-align: left;
      * {
        margin: 0;
        padding: 0;
        font-size: 0.8rem;
        font-family: var(--details_headings_font_family, inherit);
      }
      h3 {
        font-weight: var(--details_headings_font_weight, bold);
        color: var(--details_headings_font_color, #0a3b74);
        font-size: var(--details_headings_font_size, 1.25rem);
      }
    }

    .filter-dropdown {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;
    }
  }

  .filter-content {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .filter-content-sort {
    padding: 1rem;
    flex: 1;
  }

  .filter-content-price {
    padding: 1rem;
    flex: 1;
  }

  .filter-content-slider {
    min-height: 1.5rem;
    max-width: 300px;
  }

  .slide-toggler.slide-toggler-active {
    i {
      transform: rotate(90deg);
    }
  }
}

.filter-content-label {
  font-weight: bold;
  margin-bottom: 1rem;
}

.filter-content-sort {
  input {
    //position: absolute;
    width: 20px;
    height: 20px;
    max-width: 20px;
    max-height: 20px;
    min-width: 20px;
    min-height: 20px;
    cursor: pointer;
  }
}

.filter-content-sort__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.results-filter__style--radio {
  display: flex;
  gap: 2rem;
  align-items: center;
  min-height: 54px;
}

.radio-style-option {
  display: flex;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;
  gap: 0.5rem;
  margin-bottom: 0;
}

.radio-style-option input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--header_banner_search_filter_color, #034a94);
  border-radius: 50%;
  background: #fff;
  outline: none;
  margin-right: 0rem;
  position: relative;
  transition: border-color 0.2s;
  cursor: pointer;
}

.radio-style-option input[type="radio"]:checked {
  border-color: var(--header_banner_search_filter_color, #034a94);
}

.radio-style-option input[type="radio"]:checked::before {
  content: "";
  display: block;
  width: 1rem;
  height: 1rem;
  background: var(--header_banner_search_filter_color, #034a94);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.radio-style-option span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.results-filters-radio-style .results-filter {
  padding: 0 1rem;
  max-width: calc(1280px + 2rem);
}

.faqs-section .slide-toggler-wrapper {
  .slide-toggler {
    width: 100%;
    padding: 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    i {
      transition: 0.2s ease-in-out;
      transform: rotate(0deg);
    }
    .slide-toggler-text {
      display: flex;
      align-items: center;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 0.25rem;
      text-align: left;
      * {
        margin: 0;
        padding: 0;
        font-size: 0.8rem;
        font-family: var(--details_headings_font_family, inherit);
      }
      h3 {
        font-weight: var(--details_headings_font_weight, bold);
        color: var(--details_headings_font_color, #0a3b74);
        font-size: var(--details_headings_font_size, 1.25rem);
      }
    }
  }
  .slide-toggler.slide-toggler-active {
    i {
      transform: rotate(90deg);
    }
  }
}

.faqs-section {
  margin: 4rem auto;
  max-width: calc(1280px + 2rem);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  justify-content: center;
  align-items: center;
  .left-section-wrapper {
    flex: 1;
  }

  h3 {
    width: 100%;
    text-align: left;
    font-weight: bold;
  }

  .slide-toggler-border {
    //border-radius: 0.5rem;
    border-bottom: 1px solid #000;
    //border-radius: 0.5rem;
    //box-shadow: 0 3px 6px rgb(0 0 0 / 16%) !important;
    //margin-block: 0.5rem;
  }

  .slide-togglers {
    width: 100%;
    flex: 2;
  }
}

.faq-content {
  padding: 1px 1rem 1px;
}
</style>
